import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Typography,
    Grid,
    FormControlLabel,
    Switch,
    Divider,
    MenuItem,
    Modal,
    Box,
    IconButton,
    Paper,
    Snackbar,
    Select,
    Grid2,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Label } from "flowbite-react";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PlusIcon from '@mui/icons-material/Add';
import addIcon from '../../assets/icons/add.svg';
import eyeIcon from '../../assets/icons/eye.svg';
import binIcon from '../../assets/icons/bin.svg';
import { useNavigate } from 'react-router-dom';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {InputAdornment } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CommonGeofence from '../geofence/CommonGeofence';
var constants = require('../../constant');

// Modal style for viewing the image
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius:'8px'
};

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const AddVehicle = ({ onClose, editMode = false, vehicleData = {}, vehicleCityId }) => {
    localStorage.setItem('vehicleCityId', vehicleCityId);

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    console.log(editMode,"editmode")
    
    const clientId = localStorage.getItem('clientId');
    const token = localStorage.getItem('token');
    const clientDemoType = localStorage.getItem('clientDemoType');
    console.log('clientDemoType = ', clientDemoType)

    const [vehicleId, setvehicleId] = useState('');
    const [vehicleName, setVehicleName] = useState('');
    const [displayOrder, setDisplayOrder] = useState('');
    const [seats, setSeats] = useState('');
    const [enabled, setEnabled] = useState(vehicleData ?vehicleData.is_active === 1 : 1);
    const [documents, setDocuments] = useState([{ name: '', type: '', images: 1, required: false, docNumberRequired: false, isDocExpired: false, expiredAction: 1 }]);
    const [images, setImages] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [city, setCity] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [rideType, setRideType] = useState('');
    const [fareId, setfareId] = useState('');
    const [deliveryFareId, setDeliveryFareId] = useState('');
    const [baseFare, setBaseFare] = useState('');
    const [minimumFare, setMinimumFare] = useState('');
    const [thresholds, setThresholds] = useState([{ price: '', distance: '' }]);
    const [isFareModified, setIsFareModified] = useState(false);
    const [commissionPercentage, setCommissionPercentage] = useState('');
    const [commissionThreshold, setCommissionThreshold] = useState('');
    const [fixedCommission, setFixedCommission] = useState('');
    const [requestRadiusThreshold, setRequestRadiusThreshold] = useState(''); // Stores the threshold radius
    const [initialRequestRadius, setInitialRequestRadius] = useState(''); // Stores the initial request radius
    const [requestRadiusHop, setRequestRadiusHop] = useState(''); // Stores the hop/increment value
    const [convenienceCharge, setConvenienceCharge] = useState(''); // Convenience Charge value
    const [convenienceDriverCut, setConvenienceDriverCut] = useState('');
    const [minDriverBalance, setMinDriverBalance] = useState(''); // Minimum Driver Balance value
    const [platformFee, setPlatformFee] = useState('');
    const [taxName, setTaxName] = useState('');
    const [taxPercentage, setTaxPercentage] = useState('');
    const [timeBaseFare, setTimeBaseFare] = useState('');
    const [minimumTimeFare, setMinimumTimeFare] = useState('');
    const [timeThresholds, setTimeThresholds] = useState([{ timePrice: '', time: '' }]);
    const [waitingChangesWindow, setWaitingChangesWindow] = useState('');
    const [stopsWaitingChangesWindow, setStopsWaitingChangesWindow] = useState('');
    const [pickupDistanceWindow, setPickupDistanceWindow] = useState('');
    const [waitingThresholds, setWaitingThresholds] = useState([{ minDist:'', maxDist: '', charge: '', driverCut: '' }]);
    const [stopsWaitingThresholds, setStopsWaitingThresholds] = useState([{ minDist:'', maxDist: '', charge: '', driverCut: '' }]);
    const [luggageChargesDriverCut, setLuggageChargesDriverCut] = useState('');
    const [luggageCharges, setLuggageCharges] = useState('');
    const [pickupThresholds, setPickupThresholds] = useState([{pickupMinDist: '', pickupMaxDist: '', pickupCharge: '', pickupDriverCut:''}])
    const [authAmount, setAuthAmount] = useState('');
    const [authAmountType, setAuthAmountType] = useState('1');
    const [customerLowerBidLimit, setCustomerLowerBidLimit] = useState('');
    const [customerUpperBidLimit, setCustomerUpperBidLimit] = useState('');
    const [driverUpperBidLimit, setDriverUpperBidLimit] = useState('');
    const [customerBidMargin, setCustomerBidMargin] = useState('');
    const [driverBidMargin, setDriverBidMargin] = useState('');
    const [isExpandedDelivery, setIsExpandedDelivery] = useState(false);
    const [weightUnit, setWeightUnit] = useState('');
    const [sizeUnit, setSizeUnit] = useState('');
    const [perWeightFare, setPerWeightFare] = useState('');
    const [perSizeFare, setPerSizeFare] = useState('');
    const [deliveryDistanceFare, setDeliveryDistanceFare] = useState('');
    const [deliverydistanceMinFare, setDeliveryDistanceMinFare] = useState('');
    const [deliveryDistFareThreshold, setDeliveryDistFareThreshold] = useState([{ price: '', distance: '' }]);
    const [deliveryTimeFare, setDeliveryTimeFare]= useState('');
    const [deliveryTimeMinFare, setDeliveryTimeMinFare] = useState('');
    const [deliveryTimeFareThreshold, setDeliveryTimeFareThreshold] = useState([{ timePrice: '', distance: '' }]);
    const [deliveryWaitingChangesWindow, setDeliveryWaitingChangesWindow] = useState('');
    const [deliveryWaitingThresholds, setDeliveryWaitingThresholds] = useState([{ minDist:'', maxDist: '', charge: '', driverCut: '' }]);
    const [deliveryConvenienceCharge, setDeliveryConvenienceCharge] = useState('');
    const [deliveryConvenienceDriverCut, setDeliveryConvenienceDriverCut] = useState('');
    const [deliveryPlatformFee, setDeliveryPlatformFee] = useState('');
    const [deliveryCommissionPercentage, setDeliveryCommissionPercentage] = useState('');
    const [deliveryCommissionThreshold, setDeliveryCommissionThreshold] = useState('');
    const [deliveryFixedCommission, setDeliveryFixedCommission] = useState('');
    const [deliveryTaxName, setDeliveryTaxName] = useState('');
    const [deliveryTaxPercentage, setDeliveryTaxPercentag] = useState('');
    const [vehiclecreated, setvehicleCreated] = useState(editMode);
    const [multiTaxDetails, setMultiTaxDetails] = useState([{gstNumber: '', placeOfSupply: '', fullAddress: '', state: '', supplierName: '', geofence: null, taxRates: [{ taxName: '', percentage: '' }]}]);
    const [opentaxGeofence, setOpenTaxGeofence] = useState(false);
    const [polyPath, setPolyPath] = useState([]);
    const [taxGeofence, setTaxGeofence] = useState([]);
    const [fetchedTaxDetails, setFetchedTaxDetails] = useState([]);
    const [activeTaxIndex, setActiveTaxIndex] = useState(null);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [initialData, setInitialData] = useState({});

    // State for Snackbar
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [batchSize, setBatchSize] = useState(5);
    const [requestAcceptTimer, setRequestAcceptTimer] = useState(30);


    // Assuming client_cities is stored in local storage as a JSON string
    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    const reverse_bid_enabled_panel = localStorage.getItem("reverse_bid_enabled_panel") || false;
    const navigate = useNavigate();
    const isDeliveryEnabled = localStorage.getItem('is_delivery_enabled');
    const multi_tax_system_enabled = localStorage.getItem('multi_tax_system_enabled');

    // Populate form fields when in Edit mode with provided data
    useEffect(() => {
        if (editMode && vehicleData) {
            setvehicleId(vehicleData.vehicle_id || '');
            setVehicleName(vehicleData.vehicle_name || '');
            setDisplayOrder(vehicleData.display_order || '');
            setSeats(vehicleData.seat_count || '');
            setEnabled(vehicleData.is_active === 1);
            setCity(vehicleData.city_name || '');
            setVehicleType(constants.VehicleTypes[Number(vehicleData.vehicle_type)] || 'Unknown');
            setRideType(constants.RideTypes[Number(vehicleData.ride_type)] || '-');

            if (vehicleData.vehicle_image) {
                setImages([{ src: vehicleData.vehicle_image, name: 'Existing Image', isUploaded: true }]);
            } else {
                setImages([]);
            }

            if (vehicleData.vehicle_docs && vehicleData.vehicle_docs.length > 0) {
                const formattedDocs = vehicleData.vehicle_docs.map((doc) => ({
                    docId: doc.document_id,
                    name: doc.document_name,
                    type: doc.document_type === 1 ? 'Image' : 'Other',
                    images: doc.no_of_images,
                    required: doc.is_required === 1,
                    docNumberRequired: doc.is_doc_number_required === 1,
                    isDocExpired: doc.is_doc_expired === 1,
                    expiredAction: doc.expired_action
                }));
                setDocuments(formattedDocs);
            } else {
                setDocuments([{ name: '', type: '', images: 1, required: false, docNumberRequired: false, isDocExpired: false, expiredAction: 1 }]);
            }

            if (vehicleData.vehicle_fare && vehicleData.vehicle_fare.length > 0) {
                const fareData = vehicleData.vehicle_fare[0];
                setBaseFare(fareData.base_fare || '');
                setMinimumFare(fareData.minimum_fare || '');
                setfareId(fareData.fare_id || '');
                setTimeBaseFare(fareData.time_base_fare || '');
                setMinimumTimeFare(fareData.time_minimum_fare || '');
                setLuggageCharges(fareData.luggage_charges || 0);
                setLuggageChargesDriverCut(fareData.luggage_charges_driver_cut || 0);
                setPickupDistanceWindow(fareData.pickup_distance_window || 0);
                setWaitingChangesWindow(fareData.waiting_charges_window || 0);
                setStopsWaitingChangesWindow(fareData.stops_waiting_charges_window || 0);
                setCustomerLowerBidLimit(fareData.customer_lower_bid_limit || 0);
                setCustomerUpperBidLimit(fareData.customer_upper_bid_limit || 0);
                setDriverUpperBidLimit(fareData.driver_upper_bid_limit || 0);
                setCustomerBidMargin(fareData.customer_bid_margin || 0);
                setDriverBidMargin(fareData.driver_bid_margin || 0);

                if (fareData.fare_thresholds) {
                    const thresholdArray = Object.entries(fareData.fare_thresholds).map(([distance, price]) => ({
                        distance: parseInt(distance),
                        price: parseFloat(price),
                    }));
                    setThresholds(thresholdArray);
                } else {
                    setThresholds([{ distance: '', price: '' }]);
                }

                if (fareData.time_fare_thresholds) {
                    const thresholdArray = Object.entries(fareData.time_fare_thresholds).map(([time, timePrice]) => ({
                        time: parseInt(time),
                        timePrice: parseFloat(timePrice),
                    }));
                    setTimeThresholds(thresholdArray);
                } else {
                    setTimeThresholds([{ time: '', timePrice: '' }]);
                }

                if (fareData.pickup_distance_charges_thr) {
                    const thresholdArray = Object.entries(fareData.pickup_distance_charges_thr).map(([key, val]) => ({
                        pickupMaxDist: parseInt(key),
                        pickupCharge: parseInt(val.charge),
                        pickupDriverCut: parseInt(val.driver_cut)
                    }));

                    const updatedThresholdArray = thresholdArray.reduce((result, current, index) => {
                        if (index === 0) {
                            // For the first object, set pickupMinDist to 0
                            result.push({ ...current, pickupMinDist: fareData.pickup_distance_window+1 });
                        } else {
                            // For subsequent objects, set pickupMinDist to pickupMaxDist + 1 of the previous object
                            const prev = result[result.length - 1];
                            result.push({ ...current, pickupMinDist: prev.pickupMaxDist + 1 });
                        }
                        return result;
                    }, []);

                    setPickupThresholds(updatedThresholdArray);
                } else {
                    setPickupThresholds([{pickupMinDist: '', pickupMaxDist: '', pickupCharge: '', pickupDriverCut:''}]);
                }


                if (fareData.waiting_charges_thresholds) {
                    const thresholdArray = Object.entries(fareData.waiting_charges_thresholds).map(([key, val]) => ({
                        maxDist: parseInt(key),
                        charge: parseInt(val.charge),
                        driverCut: parseInt(val.driver_cut)
                    }));

                    const updatedThresholdArray = thresholdArray.reduce((result, current, index) => {
                        if (index === 0) {
                            // For the first object, set pickupMinDist to 0
                            result.push({ ...current, minDist: fareData.waiting_charges_window+1 });
                        } else {
                            // For subsequent objects, set pickupMinDist to pickupMaxDist + 1 of the previous object
                            const prev = result[result.length - 1];
                            result.push({ ...current, minDist: prev.maxDist + 1 });
                        }
                        return result;
                    }, []);

                    setWaitingThresholds(updatedThresholdArray);
                } else {
                    setWaitingThresholds([{minDist: '', maxDist: '', charge: '', driverCut:''}]);
                }

                if (fareData.stops_waiting_charges_thresholds) {
                    const thresholdArray = Object.entries(fareData.stops_waiting_charges_thresholds).map(([key, val]) => ({
                        maxDist: parseInt(key),
                        charge: parseInt(val.charge),
                        driverCut: parseInt(val.driver_cut)
                    }));

                    const updatedThresholdArray = thresholdArray.reduce((result, current, index) => {
                        if (index === 0) {
                            // For the first object, set pickupMinDist to 0
                            result.push({ ...current, minDist: fareData.stops_waiting_charges_window+1 });
                        } else {
                            // For subsequent objects, set pickupMinDist to pickupMaxDist + 1 of the previous object
                            const prev = result[result.length - 1];
                            result.push({ ...current, minDist: prev.maxDist + 1 });
                        }
                        return result;
                    }, []);

                    setStopsWaitingThresholds(updatedThresholdArray);
                } else {
                    setStopsWaitingThresholds([{minDist: '', maxDist: '', charge: '', driverCut:''}]);
                }

                if(fareData.addn_auth_amount >= 0) {
                    setAuthAmountType(fareData.addn_auth_amount_type);
                    setAuthAmount(fareData.addn_auth_amount);
                }
            }

            if (vehicleData.vehicle_fare && vehicleData.vehicle_fare.length > 1) {
                const fareData = vehicleData.vehicle_fare[1];
                setDeliveryDistanceFare(fareData.base_fare || '');
                setDeliveryDistanceMinFare(fareData.minimum_fare || '');
                setDeliveryFareId(fareData.fare_id || '');
                setDeliveryTimeFare(fareData.time_base_fare || '');
                setDeliveryTimeMinFare(fareData.time_minimum_fare || '');
                setDeliveryWaitingChangesWindow(fareData.waiting_charges_window || 0);
                setSizeUnit(fareData.size_unit);
                setPerSizeFare(fareData.size_per_unit_fare);
                setWeightUnit(fareData.weight_unit);
                setPerWeightFare(fareData.weight_per_unit_fare);

                if (fareData.fare_thresholds) {
                    const thresholdArray = Object.entries(fareData.fare_thresholds).map(([distance, price]) => ({
                        distance: parseInt(distance),
                        price: parseFloat(price),
                    }));
                    setDeliveryDistFareThreshold(thresholdArray);
                } else {
                    setDeliveryDistFareThreshold([{ distance: '', price: '' }]);
                }

                if (fareData.time_fare_thresholds) {
                    const thresholdArray = Object.entries(fareData.time_fare_thresholds).map(([time, timePrice]) => ({
                        time: parseInt(time),
                        timePrice: parseFloat(timePrice),
                    }));
                    setDeliveryTimeFareThreshold(thresholdArray);
                } else {
                    setDeliveryTimeFareThreshold([{ time: '', timePrice: '' }]);
                }

                if (fareData.waiting_charges_thresholds) {
                    const thresholdArray = Object.entries(fareData.waiting_charges_thresholds).map(([key, val]) => ({
                        maxDist: parseInt(key),
                        charge: parseInt(val.charge),
                        driverCut: parseInt(val.driver_cut)
                    }));

                    const updatedThresholdArray = thresholdArray.reduce((result, current, index) => {
                        if (index === 0) {
                            // For the first object, set pickupMinDist to 0
                            result.push({ ...current, minDist: fareData.waiting_charges_window+1 });
                        } else {
                            // For subsequent objects, set pickupMinDist to pickupMaxDist + 1 of the previous object
                            const prev = result[result.length - 1];
                            result.push({ ...current, minDist: prev.maxDist + 1 });
                        }
                        return result;
                    }, []);

                    setDeliveryWaitingThresholds(updatedThresholdArray);
                } else {
                    setDeliveryWaitingThresholds([{minDist: '', maxDist: '', charge: '', driverCut:''}]);
                }
            }

            setCommissionPercentage(vehicleData.commission_percentage || 0);
            setCommissionThreshold(vehicleData.commission_threshold || 0);
            setFixedCommission(vehicleData.fixed_commission || 0);

            setRequestRadiusThreshold(vehicleData.request_radius_threshold || 0);
            setInitialRequestRadius(vehicleData.initial_request_radius || 0);
            setRequestRadiusHop(vehicleData.request_radius_hop || 0);
            setBatchSize(vehicleData.batch_size || 0);
            setRequestAcceptTimer(vehicleData.request_accept_timer || 0);

            setConvenienceCharge(vehicleData.convenience_charge || 0);
            setMinDriverBalance(vehicleData.min_driver_balance || 0);
            setConvenienceDriverCut(vehicleData.convenience_driver_cut || 0);
            setPlatformFee(vehicleData.platform_fee || 0);
            setTaxName(vehicleData.tax_name || '');
            setTaxPercentage(vehicleData.tax_percentage || 0);

            setDeliveryCommissionPercentage(vehicleData.delivery_commission_percentage || 0);
            setDeliveryCommissionThreshold(vehicleData.delivery_commission_threshold || 0);
            setDeliveryFixedCommission(vehicleData.delivery_fixed_commission || 0);
            setDeliveryConvenienceCharge(vehicleData.delivery_convenience_charge || 0);
            setDeliveryConvenienceDriverCut(vehicleData.delivery_convenience_driver_cut || 0);
            setDeliveryPlatformFee(vehicleData.delivery_platform_fee || 0);
            setDeliveryTaxName(vehicleData.delivery_tax_name || '');
            setDeliveryTaxPercentag(vehicleData.delivery_tax_percentage || 0);

            setInitialData({
                vehicle_name: vehicleData.vehicle_name || '',
                display_order: vehicleData.display_order || '',
                seat_count: vehicleData.seat_count || '',
                is_active: vehicleData.is_active === 1,
                city_name: vehicleData.city_name || '',
                ride_type: constants.RideTypes[Number(vehicleData.ride_type)] || 'Unknown',
                vehicle_type: constants.VehicleTypes[Number(vehicleData.vehicle_type)] || 'Unknown',
                vehicle_image: vehicleData.vehicle_image || null,
                commission_percentage: vehicleData.commission_percentage || 0,
                commission_threshold: vehicleData.commission_threshold || 0,
                fixed_commission: vehicleData.fixed_commission ||0,
                request_radius_threshold: vehicleData.request_radius_threshold || '',
                initial_request_radius: vehicleData.initial_request_radius || '',
                request_radius_hop: vehicleData.request_radius_hop || '',
                batch_size: vehicleData.batch_size || '',
                request_accept_timer: vehicleData.request_accept_timer || '',
                waiting_time_threshold: vehicleData.waiting_time_threshold || '',
                waiting_charges: vehicleData.waiting_charges || '',
                convenience_charge: vehicleData.convenience_charge || 0,
                min_driver_balance: vehicleData.min_driver_balance || '',
                convenience_driver_cut: vehicleData.convenience_driver_cut || 0,
                platform_fee: vehicleData.platform_fee || 0,
                tax_name: vehicleData.tax_name || '',
                tax_percentage: vehicleData.tax_percentage || 0,
                delivery_commission_percentage: vehicleData.delivery_commission_percentage || 0,
                delivery_commission_threshold: vehicleData.delivery_commission_threshold || 0,
                delivery_fixed_commission: vehicleData.delivery_fixed_commission || 0,
                delivery_convenience_charge: vehicleData.delivery_convenience_charge || 0,
                delivery_convenience_driver_cut: vehicleData.delivery_convenience_driver_cut || 0,
                delivery_platform_fee: vehicleData.delivery_platform_fee || 0,
                delivery_tax_name: vehicleData.delivery_tax_name || '',
                delivery_tax_percentage: vehicleData.delivery_tax_percentage || 0
            });
        }
        else{
            setCity(clientCities.find(city => city.city_id === vehicleCityId)?.city_name);
        }
    }, [editMode, vehicleData]);

    const fetchTaxDetails = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/shuttle/fetch_tax_details';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                vehicle_type_id: vehicleId,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setFetchedTaxDetails(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    };
    useEffect(() => {
        if(vehicleId)
        fetchTaxDetails();
    },[vehicleId]);

    const handleAddImage = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('image', file);
    
            try {
                const response = await axios.post(operationsUrl + '/upload_image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                const s3Url = response.data.url;
                const newImage = {
                    name: file.name,
                    src: s3Url,
                    isUploaded: true,
                };
    
                setImages([newImage]); // Restrict to one image
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };
    
    const getFilteredRideTypes = () => {
        const allRideTypes = Object.entries(constants.RideTypes);
        
        if (isDeliveryEnabled != 0) {
            let filtered = allRideTypes;
            
            if (clientDemoType == 1) {
                filtered = filtered.filter(([id, label]) => id !== '2');
            }
            return filtered;
        }
        
        if (clientDemoType == 1) {
            return allRideTypes.filter(([id, label]) => id === '1');
        } else {
            const allowedIds = ['1', '2'];
            return allRideTypes.filter(([id, label]) => allowedIds.includes(id));
        }
    };

    const handleDeleteImage = async (index) => {
        const imageToDelete = images[index];
        if (!imageToDelete || !imageToDelete.src) {
            console.error('No image to delete');
            return;
        }

        try {
            // Send an update request to clear the vehicle_image key in the database
            const updateData = {
                token: token,
                vehicle_id: vehicleId,
                vehicle_image: '',
            };

            await axios.post(operationsUrl + '/update_client_vehicle_type', updateData);
            setImages([]);
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };          

    const handleViewImage = (image) => {
        setCurrentImage(image);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentImage(null);
    };

    const handleUpdateDocument = async (index) => {
        const doc = documents[index];
        if(doc.images > 2){
            setSnackbarMessage('The number of images must be either 1 or 2.');
            setOpenSnackbar(true);
            return;
        }
        const documentData = {
            token: token,
            document_id: doc.docId, // Use docId for update
            document_name: doc.name,
            document_type: doc.type === 'Image' ? 1 : 2,
            no_of_images: doc.images,
            is_doc_number_required: doc.docNumberRequired ? 1 : 0,
            is_required: doc.required ? 1 : 0,
            is_doc_expired: doc.isDocExpired ? 1 : 0,
            is_active: 1,
            expired_action: doc.expiredAction
        };
    
        try {
            await axios.post(operationsUrl + '/update_vehicle_documents', documentData);
            const updatedDocuments = [...documents];
            updatedDocuments[index].isModified = false; // Reset modified state
            setDocuments(updatedDocuments);
            setSnackbarMessage('Document updated successfully');
            setOpenSnackbar(true);
        } catch (error) {
            console.error('Error updating document:', error);
            setSnackbarMessage('Failed to update document');
            setOpenSnackbar(true);
        }
    };
    
    const handleDeleteDocument = async (index) => {
        const doc = documents[index];
        if (!doc.docId) return; // Skip if there's no docId
    
        try {
            await axios.post(operationsUrl + '/update_vehicle_documents', {
                token: token,
                document_id: doc.docId,
                is_active: 0, // Mark document as inactive
            });
            const updatedDocuments = documents.filter((_, i) => i !== index);
            setDocuments(updatedDocuments);
        } catch (error) {
            console.error('Error deleting document:', error);
        }
    };    

    const handleDocumentChange = (index, field, value) => {
        const updatedDocuments = [...documents];
        updatedDocuments[index][field] = value;
    
        // Mark as modified only if it already exists in the database
        if (updatedDocuments[index].docId) {
            updatedDocuments[index].isModified = true;
        }
    
        setDocuments(updatedDocuments);
    };

    const handleSaveNewDocument = async (index) => {
        const doc = documents[index];
        console.log('vehicleId = ', vehicleId)
        const documentData = {
            token: token,
            document_name: doc.name,
            vehicle_id: vehicleId,
            city_id: clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '',
            client_id: clientId,
            document_type: doc.type === 'Image' ? 1 : 2,
            no_of_images: doc.images,
            is_doc_number_required: doc.docNumberRequired ? 1 : 0,
            is_required: doc.required ? 1 : 0,
            is_doc_expired: doc.isDocExpired ? 1 : 0,
            is_active: 1,
            expired_action: doc.expiredAction
        };
    
        try {
            const response = await axios.post(operationsUrl + '/insert_vehicle_documents', documentData);
    
            if(response.data.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }
            if (response.data.flag === 200 && response.data.document_id) {
                setDocuments((prevDocuments) => {
                    const updatedDocuments = [...prevDocuments];
                    updatedDocuments[index] = {
                        ...doc,
                        docId: response.data.document_id, // Use the returned document_id
                        isModified: false, // Reset modified state
                    };
                    return updatedDocuments;
                });
            } else {
                console.error('Failed to save document:', response.data.message);
            }
        } catch (error) {
            console.error('Error saving new document:', error);
        }
    };
    
    const getUpdatedFields = () => {
        const updatedFields = {};
        console.log('clientDemoType= ', clientDemoType)
    
        if (initialData.vehicle_name !== vehicleName) {
            updatedFields.vehicle_name = vehicleName;
        }
        if (initialData.display_order !== displayOrder && clientDemoType!=2) {
            updatedFields.display_order = displayOrder;
        }
        if (initialData.seat_count !== seats && clientDemoType!=2) {
            updatedFields.seat_count = seats;
        }
        if (initialData.is_active !== enabled) {
            updatedFields.is_active = enabled ? 1 : 0;
        }
        if (initialData.city_name !== city) {
            updatedFields.city_id = clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '';
        }
        if (initialData.vehicle_type !== vehicleType) {
            updatedFields.vehicle_type = Object.entries(constants.VehicleTypes).find(([key, value]) => value === vehicleType)?.[0] || null;
        }

        if (initialData.ride_type !== rideType) {
            updatedFields.ride_type = Object.entries(constants.RideTypes).find(([key, value]) => value === rideType)?.[0] || null;
        }
        if (initialData.vehicle_image !== (images.length > 0 ? images[0].src : null)) {
            updatedFields.vehicle_image = images.length > 0 ? images[0].src : undefined;
        }

        if(rideType !== 'Delivery'){
            if (commissionPercentage !== initialData.commission_percentage && clientDemoType!=2) {
                updatedFields.commission_percentage = parseInt(commissionPercentage);
            }
            if (commissionThreshold !== initialData.commission_threshold && clientDemoType!=2) {
                updatedFields.commission_threshold = parseInt(commissionThreshold);
            }
            if (fixedCommission !== initialData.fixed_commission && clientDemoType!=2) {
                updatedFields.fixed_commission = parseInt(fixedCommission);
            }
            if(convenienceDriverCut != initialData.convenience_driver_cut && clientDemoType!=2) {
                updatedFields.convenience_driver_cut = parseInt(convenienceDriverCut);
            }
            if(platformFee != initialData.platform_fee && clientDemoType!=2){
                updatedFields.platform_fee = parseInt(platformFee);
            }
            if(taxName != initialData.tax_name && clientDemoType!=2) {
                updatedFields.tax_name = taxName;
            }
            if(taxPercentage != initialData.tax_percentage && clientDemoType!=2){
                updatedFields.tax_percentage = taxPercentage;
            }
            // Convenience charge
            if (convenienceCharge !== initialData.convenience_charge && clientDemoType!=2) {
                updatedFields.convenience_charge = parseInt(convenienceCharge);
            }
        }

        if (requestRadiusThreshold !== initialData.request_radius_threshold && clientDemoType!=2) {
            updatedFields.request_radius_threshold = parseInt(requestRadiusThreshold);
        }
        if (initialRequestRadius !== initialData.initial_request_radius && clientDemoType!=2) {
            updatedFields.initial_request_radius = parseInt(initialRequestRadius);
        }
        if (requestRadiusHop !== initialData.request_radius_hop && clientDemoType!=2) {
            updatedFields.request_radius_hop = parseInt(requestRadiusHop);
        }

        if (batchSize !== initialData.batch_size && clientDemoType!=2) {
            updatedFields.batch_size = parseInt(batchSize);
        }

        if (requestAcceptTimer !== initialData.request_accept_timer && clientDemoType!=2) {
            updatedFields.request_accept_timer = parseInt(requestAcceptTimer);
        }

        // Minimum driver balance
        if (minDriverBalance !== initialData.min_driver_balance && clientDemoType!=2) {
            updatedFields.min_driver_balance = parseInt(minDriverBalance);
        }

        if(rideType === 'Delivery' || rideType === 'Normal and Delivery'){
            if (deliveryCommissionPercentage !== initialData.delivery_commission_percentage && clientDemoType!=2) {
                updatedFields.delivery_commission_percentage = parseInt(deliveryCommissionPercentage);
            }
            if (deliveryCommissionThreshold !== initialData.delivery_commission_threshold && clientDemoType!=2) {
                updatedFields.delivery_commission_threshold = parseInt(deliveryCommissionThreshold);
            }
            if (deliveryFixedCommission !== initialData.delivery_fixed_commission && clientDemoType!=2) {
                updatedFields.delivery_fixed_commission = parseInt(deliveryFixedCommission);
            }
            if (deliveryConvenienceCharge !== initialData.delivery_convenience_charge && clientDemoType!=2) {
                updatedFields.delivery_convenience_charge = parseInt(deliveryConvenienceCharge);
            }
            if(deliveryConvenienceDriverCut != initialData.delivery_convenience_driver_cut && clientDemoType!=2) {
                updatedFields.delivery_convenience_driver_cut = parseInt(deliveryConvenienceDriverCut);
            }
            if(deliveryTaxName != initialData.delivery_tax_name && clientDemoType!=2) {
                updatedFields.delivery_tax_name = deliveryTaxName;
            }
            if(deliveryTaxPercentage != initialData.delivery_tax_percentage && clientDemoType!=2){
                updatedFields.delivery_tax_percentage = deliveryTaxPercentage;
            }
            if(deliveryPlatformFee != initialData.delivery_platform_fee && clientDemoType!=2){
                updatedFields.delivery_platform_fee = deliveryPlatformFee;
            }
        }
    
        return updatedFields;
    };
    
    // Function to handle saving the vehicle
    const handleSubmit = async () => {
        const updatedFields = getUpdatedFields();
        
        if (Object.keys(updatedFields).length === 0) {
            setSnackbarMessage('No changes to update');
            setOpenSnackbar(true);
            return; // No changes, no need to call the API
        }
    
        // Add token and other required fields
        updatedFields.token = token;
        updatedFields.client_id = clientId;
        
        // if(imageDeleted == false){
            if (vehicleId) {
                // Update existing vehicle
                updatedFields.vehicle_id = vehicleId; // Mandatory vehicle_id for updates
        
                try {
                    const response = await axios.post(operationsUrl + '/update_client_vehicle_type', updatedFields);
                    if(response.data.flag==102){
                        console.log('Token is expired. Please login again')
                        localStorage.removeItem('token');
                        setErrorMessage('Your session has expired. Please log in again.');
                        setTokenExpired(true);

                        setTimeout(() => {
                            navigate('/signup');
                        }, 2000);
                    }
                    if (response.data.flag === 200) {
                        localStorage.setItem('saveCityId', clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '');
                        setvehicleCreated(true);
                        // console.log('saveCityId = ', clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '')
                        window.location.reload();
                    }
                    else {
                        console.error('Failed to update vehicle:', response.data.message);
                    }
                } catch (error) {
                    console.error('Error submitting vehicle form:', error);
                }
            } else {
                // Create a new vehicle
                try {
                    const response = await axios.post(operationsUrl + '/create_client_vehicle_type', updatedFields);
                    
                    if(response.data.flag==102){
                        console.log('Token is expired. Please login again')
                        localStorage.removeItem('token');
                        setErrorMessage('Your session has expired. Please log in again.');
                        setTokenExpired(true);

                        setTimeout(() => {
                            navigate('/signup');
                        }, 2000);
                    }

                    if (response.data.flag === 200) {
                        setSnackbarMessage('Vehicle updated successfully!');
                        setOpenSnackbar(true);
                        localStorage.setItem('saveCityId', clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '');
                        setvehicleCreated(true);
                        // window.location.reload();
                    } else {
                        setSnackbarMessage('Failed to update vehicle. Please try again.');
                        setOpenSnackbar(true);
                    }
                } catch (error) {
                    setSnackbarMessage('Error updating vehicle. Please try again.');
                    setOpenSnackbar(true);
                }
            }
        // }
        // else{
            localStorage.setItem('saveCityId', clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '');
            window.location.reload();
        // }
    
        onClose(); // Close modal if needed
    };

    const handleSaveFareSettings = async () => {
        if(customerLowerBidLimit>customerUpperBidLimit){
            setSnackbarMessage("'Customer Lower Bid Limit' should be less than 'Customer Upper Bid Limit'");
            setOpenSnackbar(true);
            return;
        }
        if(customerLowerBidLimit>100){
            setSnackbarMessage("'Customer Lower Bid Limit' should be less than 100");
            setOpenSnackbar(true);
            return;
        }
        if(customerUpperBidLimit>100){
            setSnackbarMessage("'Customer Upper Bid Limit' should be less than 100");
            setOpenSnackbar(true);
            return;
        }
        if(driverUpperBidLimit>100){
            setSnackbarMessage("'Driver Upper Bid Limit' should be less than 100");
            setOpenSnackbar(true);
            return;
        }
        if (thresholds.length > 0) {
            const fareThresholds = thresholds.reduce((acc, curr) => {
                acc[curr.distance] = curr.price;
                return acc;
            }, {});
            if(timeThresholds.length > 0){
                var timeThreshold = timeThresholds.reduce((acc, curr) => {
                    acc[curr.time] = curr.timePrice;
                    return acc;
                }, {});
            }

            if(waitingThresholds.length > 0){
                var waitingThreshold = waitingThresholds.reduce((acc, curr) => {
                    acc[curr.maxDist]={
                        charge: curr.charge,
                        driver_cut: curr.driverCut
                    }
                    return acc;
                }, {});
            }

            if(pickupThresholds.length > 0){
                // console.log('pickup thresholds = ', pickupThresholds)
                var pickupThreshold = pickupThresholds.reduce((acc, curr) => {
                    acc[curr.pickupMaxDist]={
                        charge: curr.pickupCharge,
                        driver_cut: curr.pickupDriverCut
                    }
                    return acc;
                }, {});
            }
    
            const fareData = {
                token: token,
                fare_id: fareId || undefined, // Include fareId only if it exists
                clt_vehicle_id: vehicleId
            };
            console.log("waitingThresholds", waitingThresholds)
            if (pickupThresholds[0].pickupMaxDist !== '') {
                const filteredPickupThreshold = Object.entries(pickupThreshold).reduce((acc, [key, value]) => {
                    if (value.charge !== null && value.charge !== "" && 
                        value.driver_cut !== null && value.driver_cut !== "") {
                        acc[key] = value;
                    }
                    return acc;
                }, {});
                
                if (Object.keys(filteredPickupThreshold).length > 0) {
                    fareData['pickup_distance_charges_thr'] = filteredPickupThreshold;
                }
            }
            if(luggageChargesDriverCut !== ''){
                fareData['luggage_charges_driver_cut'] = luggageChargesDriverCut;
            }
            if(luggageCharges !== ''){
                fareData['luggage_charges'] = luggageCharges;
            }
            if(waitingThresholds[0].maxDist!=''){
                const filteredWaitingChargesThreshold = Object.entries(waitingThreshold).reduce((acc, [key, value]) => {
                    if (value.charge !== null && value.charge !== "" && 
                        value.driver_cut !== null && value.driver_cut !== "") {
                        acc[key] = value;
                    }
                    return acc;
                }, {});
                
                if (Object.keys(filteredWaitingChargesThreshold).length > 0) {
                    fareData['waiting_charges_thresholds'] = filteredWaitingChargesThreshold;
                }
            }
            if(stopsWaitingThresholds[0].maxDist!=''){
                const filteredStopsWaitingThresholds = stopsWaitingThresholds.reduce((acc, curr) => {
                    if (curr.charge !== '' && curr.driverCut !== '') {
                        acc[curr.maxDist] = {
                            charge: curr.charge,
                            driver_cut: curr.driverCut
                        };
                    }
                    return acc;
                }, {});
                if (Object.keys(filteredStopsWaitingThresholds).length > 0) {
                    fareData['stops_waiting_charges_thresholds'] = filteredStopsWaitingThresholds;
                }
            }
            if(minimumTimeFare){
                fareData['time_minimum_fare']=parseFloat(minimumTimeFare);
            }
            if(timeBaseFare){
                fareData['time_base_fare'] = parseFloat(timeBaseFare);
            }
            if(minimumFare){
                fareData['minimum_fare'] = parseFloat(minimumFare);
            }
            if(baseFare){
                fareData['base_fare'] = parseFloat(baseFare);
            }
            if(timeThresholds[0].time!=''){
                const filteredTimeThresholds = Object.entries(timeThreshold).reduce((acc, [key, value]) => {
                    if (key !== "" && value !== "") {  // Check both key and value are not empty strings
                        acc[key] = value;
                    }
                    return acc;
                }, {});
                
                if (Object.keys(filteredTimeThresholds).length > 0) {
                    fareData['time_fare_thresholds'] = filteredTimeThresholds;
                }
            }
            if(thresholds[0].distance!=''){
                const filteredFareThresholds = Object.entries(fareThresholds).reduce((acc, [key, value]) => {
                    if (key !== "" && value !== "") {  // Check both key and value are not empty strings
                        acc[key] = value;
                    }
                    return acc;
                }, {});
                
                if (Object.keys(filteredFareThresholds).length > 0) {
                    fareData['fare_thresholds'] = filteredFareThresholds;
                }
            }
            if(waitingChangesWindow){
                fareData['waiting_charges_window'] = waitingChangesWindow;
            }
            if(stopsWaitingChangesWindow){
                fareData['stops_waiting_charges_window'] = stopsWaitingChangesWindow;
            }
            if(pickupDistanceWindow){
                fareData['pickup_distance_window'] = pickupDistanceWindow;
            }
            if(authAmount>=0){
                fareData['addn_auth_amount_type'] = authAmountType;
                fareData['addn_auth_amount'] = authAmount;
            }
            else if(authAmount == null){
                fareData['addn_auth_amount'] = 0;
            }
            if(customerLowerBidLimit){
                fareData['customer_lower_bid_limit'] = customerLowerBidLimit;
            }
            if(customerUpperBidLimit){
                fareData['customer_upper_bid_limit'] = customerUpperBidLimit;
            }
            if(driverUpperBidLimit){
                fareData['driver_upper_bid_limit'] = driverUpperBidLimit;
            }
            if(customerBidMargin){
                fareData['customer_bid_margin'] = customerBidMargin;
            }
            if(driverBidMargin){
                fareData['driver_bid_margin'] = driverBidMargin;
            }
    
            try {
                const response = await axios.post(operationsUrl + '/create_and_update_vehicle_fare', fareData);

                // Check if response is successful
                if (response.status === 200) {
                    setSnackbarMessage('Updated Successfully!');
                    setOpenSnackbar(true); // Show success message

                    // Update the local state with the new fare settings
                    setBaseFare(fareData.base_fare);
                    setMinimumFare(fareData.minimum_fare);
                    localStorage.setItem('saveCityId', clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '');
                    window.location.reload();
                }
            } catch (error) {
                setSnackbarMessage('Error updating fare settings');
                setOpenSnackbar(true); // Show error message
            }
        }
    };

    const handleSaveDeliveryFareSettings = async () => {
        try {
            console.log('here in delivery');
            
            // Initialize fareThresholds as an empty object
            let fareThresholds = {};
            if (deliveryDistFareThreshold.length > 0 && deliveryDistFareThreshold[0]?.distance !== '') {
                fareThresholds = deliveryDistFareThreshold.reduce((acc, curr) => {
                    if (curr?.distance !== '' && curr?.price !== '') {
                        acc[curr.distance] = curr.price;
                    }
                    return acc;
                }, {});
            }

            // Initialize timeThreshold as an empty object
            let timeThreshold = {};
            if (deliveryTimeFareThreshold.length > 0 && deliveryTimeFareThreshold[0]?.time !== '') {
                timeThreshold = deliveryTimeFareThreshold.reduce((acc, curr) => {
                    if (curr?.time !== '' && curr?.timePrice !== '') {
                        acc[curr.time] = curr.timePrice;
                    }
                    return acc;
                }, {});
            }

            // Initialize waitingThreshold as an empty object
            let waitingThreshold = {};
            if (deliveryWaitingThresholds.length > 0 && deliveryWaitingThresholds[0]?.maxDist !== '') {
                waitingThreshold = deliveryWaitingThresholds.reduce((acc, curr) => {
                    if (curr?.maxDist !== '' && curr?.charge !== '' && curr?.driverCut !== '') {
                        acc[curr.maxDist] = {
                            charge: curr.charge,
                            driver_cut: curr.driverCut
                        };
                    }
                    return acc;
                }, {});
            }

            const fareData = {
                token: token,
                fare_id: deliveryFareId || undefined,
                clt_vehicle_id: vehicleId,
            };

            if (!deliveryFareId) {
                fareData['is_delivery'] = 1;
            }

            // Only add waiting_charges_thresholds if waitingThreshold has data
            if (Object.keys(waitingThreshold).length > 0) {
                fareData['waiting_charges_thresholds'] = waitingThreshold;
            }

            if (deliveryTimeMinFare) {
                fareData['time_minimum_fare'] = parseFloat(deliveryTimeMinFare);
            }
            if (deliveryTimeFare) {
                fareData['time_base_fare'] = parseFloat(deliveryTimeFare);
            }
            if (deliverydistanceMinFare) {
                fareData['minimum_fare'] = parseFloat(deliverydistanceMinFare);
            }
            if (deliveryDistanceFare) {
                fareData['base_fare'] = parseFloat(deliveryDistanceFare);
            }
            if (weightUnit) {
                fareData['weight_unit'] = weightUnit;
            }
            if (perWeightFare) {
                fareData['weight_per_unit_fare'] = perWeightFare;
            }
            if (sizeUnit) {
                fareData['size_unit'] = sizeUnit;
            }
            if (perSizeFare) {
                fareData['size_per_unit_fare'] = perSizeFare;
            }

            // Only add time_fare_thresholds if timeThreshold has data
            if (Object.keys(timeThreshold).length > 0) {
                fareData['time_fare_thresholds'] = timeThreshold;
            }

            // Only add fare_thresholds if fareThresholds has data
            if (Object.keys(fareThresholds).length > 0) {
                fareData['fare_thresholds'] = fareThresholds;
            }

            if (deliveryWaitingChangesWindow) {
                fareData['waiting_charges_window'] = deliveryWaitingChangesWindow;
            }

            const response = await axios.post(operationsUrl + '/create_and_update_vehicle_fare', fareData);

            if (response.status === 200) {
                setSnackbarMessage('Updated Successfully!');
                setOpenSnackbar(true);
                localStorage.setItem('saveCityId', clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '');
                window.location.reload();
            }
        } catch (error) {
            console.error('Error saving delivery fare settings:', error);
            setSnackbarMessage('Error updating fare settings: ' + (error.response?.data?.message || error.message));
            setOpenSnackbar(true);
        }
    };

    useEffect(() => {
        if (
            baseFare !== '' ||
            minimumFare !== '' ||
            thresholds.some(threshold => threshold.price !== '' || threshold.distance !== '')
        ) {
            setIsFareModified(true);
        } else {
            setIsFareModified(false);
        }
    }, [baseFare, minimumFare, thresholds]);

    const handleAddThreshold = () => {
        setThresholds([...thresholds, { price: '', distance: '' }]);
    };
    const handleAddDeliveryDistFareThreshold = () => {
        setDeliveryDistFareThreshold([...deliveryDistFareThreshold, { price: '', distance: '' }]);
    }

    const handleAddTimeThreshold = () => {
        setTimeThresholds([...timeThresholds, { timePrice: '', time: '' }]);
    };

    const handleAddDeliveryTimeThreshold = () => {
        setDeliveryTimeFareThreshold([...deliveryTimeFareThreshold, { timePrice: '', time: '' }]);
    };

    const handleAddWaitingThreshold = () => {
        const lastMaxDist = waitingThresholds.length > 0 ? Number(waitingThresholds[waitingThresholds.length - 1].maxDist) : waitingChangesWindow;

        setWaitingThresholds([...waitingThresholds, { minDist: lastMaxDist + 1, maxDist: '', charge: '', driverCut:'' }]);
    };

    const handleAddDeliveryWaitingThreshold = () => {
        const lastMaxDist = deliveryWaitingThresholds.length > 0 ? Number(deliveryWaitingThresholds[deliveryWaitingThresholds.length - 1].maxDist) : deliveryWaitingChangesWindow;

        setDeliveryWaitingThresholds([...deliveryWaitingThresholds, { minDist: lastMaxDist + 1, maxDist: '', charge: '', driverCut:'' }]);
    };

    const handleAddStopsWaitingThreshold = () => {
        const lastMaxDist = stopsWaitingThresholds.length > 0 ? Number(stopsWaitingThresholds[stopsWaitingThresholds.length - 1].maxDist) : stopsWaitingChangesWindow;

        setStopsWaitingThresholds([...stopsWaitingThresholds, { minDist: lastMaxDist + 1, maxDist: '', charge: '', driverCut:'' }]);
    };

    const handleAddPickupThreshold = () => {
        const lastMaxDist = pickupThresholds.length > 0 ? Number(pickupThresholds[pickupThresholds.length - 1].pickupMaxDist) : pickupDistanceWindow;

        setPickupThresholds([...pickupThresholds, { pickupMinDist: lastMaxDist+1, pickupMaxDist: '', pickupCharge: '', pickupDriverCut:'' }]);
    };

    const handleRemoveThreshold = (index) => {
        const updatedThresholds = thresholds.filter((_, i) => i !== index);
        setThresholds(updatedThresholds);
    };

    const handleRemoveDeliveryDistFareThreshold = (index) => {
        const updatedThresholds = deliveryDistFareThreshold.filter((_, i) => i !== index);
        setDeliveryDistFareThreshold(updatedThresholds);
    }

    const handleRemoveTimeThreshold = (index) => {
        const updatedThresholds = timeThresholds.filter((_, i) => i !== index);
        setTimeThresholds(updatedThresholds);
    };
    const handleRemoveDeliveryTimeThreshold = (index) => {
        const updatedThresholds = deliveryTimeFareThreshold.filter((_, i) => i !== index);
        setDeliveryTimeFareThreshold(updatedThresholds);
    };

    const handleRemoveWaitingThreshold = (index) => {
        const updatedThresholds = waitingThresholds.filter((_, i) => i !== index);
        setWaitingThresholds(updatedThresholds);
    };
    const handleRemoveDeliveryWaitingThreshold = (index) => {
        const updatedThresholds = deliveryWaitingThresholds.filter((_, i) => i !== index);
        setDeliveryWaitingThresholds(updatedThresholds);
    };

    const handleRemoveStopsWaitingThreshold = (index) => {
        const updatedThresholds = stopsWaitingThresholds.filter((_, i) => i !== index);
        setStopsWaitingThresholds(updatedThresholds);
    };

    const handleRemovePickupThreshold = (index) => {
        const updatedThresholds = pickupThresholds.filter((_, i) => i !== index);
        setPickupThresholds(updatedThresholds);
    };

    const handleThresholdChange = (index, field, value) => {
        const updatedThresholds = thresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setThresholds(updatedThresholds);
    };

    const handleDeliveryDistFareThresholdChange = (index, field, value) => {
        const updatedThresholds = deliveryDistFareThreshold.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setDeliveryDistFareThreshold(updatedThresholds);
    };

    const handleTimeThresholdChange = (index, field, value) => {
        const updatedThresholds = timeThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setTimeThresholds(updatedThresholds);
    };

    const handleDeliveryTimeThresholdChange = (index, field, value) => {
        const updatedThresholds = deliveryTimeFareThreshold.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setDeliveryTimeFareThreshold(updatedThresholds);
    };

    const handleWaitingThresholdChange = (index, field, value) => {
        const updatedThresholds = waitingThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setWaitingThresholds(updatedThresholds);
    };
    const handleDeliveryWaitingThresholdChange = (index, field, value) => {
        const updatedThresholds = deliveryWaitingThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setDeliveryWaitingThresholds(updatedThresholds);
    };

    const handleStopsWaitingThresholdChange = (index, field, value) => {
        const updatedThresholds = stopsWaitingThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setStopsWaitingThresholds(updatedThresholds);
    };

    const handlePickupThresholdChange = (index, field, value) => {
        const updatedThresholds = pickupThresholds.map((threshold, i) =>
            i === index ? { ...threshold, [field]: value } : threshold
        );
        setPickupThresholds(updatedThresholds);
    };

    const handleMultiTaxChange = (index, field, value) => {
        const updatedTax = [...multiTaxDetails];
        updatedTax[index][field] = value;
    
        // Mark as modified only if it already exists in the database
        if (updatedTax[index].taxId) {
            updatedTax[index].isModified = true;
        }
    
        setMultiTaxDetails(updatedTax);
    };

    const handleTaxRateChange = (taxIndex, rateIndex, field, value) => {
        const updated = [...multiTaxDetails];
        updated[taxIndex].taxRates[rateIndex][field] = value;
        if (updated[taxIndex].taxId) updated[taxIndex].isModified = true;
        setMultiTaxDetails(updated);
    };
    
    const addTaxRate = (taxIndex) => {
        const updated = [...multiTaxDetails];
        if (!updated[taxIndex].taxRates) updated[taxIndex].taxRates = [];
        updated[taxIndex].taxRates.push({ taxName: '', percentage: '' });
        if (updated[taxIndex].taxId) updated[taxIndex].isModified = true;
        setMultiTaxDetails(updated);
    };
    
    const removeTaxRate = (taxIndex, rateIndex) => {
        const updated = [...multiTaxDetails];
        updated[taxIndex].taxRates.splice(rateIndex, 1);
        if (updated[taxIndex].taxId) updated[taxIndex].isModified = true;
        setMultiTaxDetails(updated);
    };

    const openGeofenceModalForTax = (index) => {
        setOpenTaxGeofence(true);
        setActiveTaxIndex(index);
    }

    const handleUpdatePolygon = (polygonPath) => {
        if (activeTaxIndex === null) return;
        const updated = [...multiTaxDetails];
        updated[activeTaxIndex].geofence = polygonPath;
        if (updated[activeTaxIndex].taxId) updated[activeTaxIndex].isModified = true;
        setMultiTaxDetails(updated);
    };

    const handleDeleteMultiTax = async (index) => {
        const tax = multiTaxDetails[index];
        if (!tax.taxId) return; // Skip if there's no docId
    
        try {
            const response = await makePostRequestToUrl(operationsUrl + '/shuttle/add_update_tax_details', {
                token: token,
                tax_id: tax.taxId,
                is_active: 0, // Mark document as inactive
            });
            const updatedTax = multiTaxDetails.filter((_, i) => i !== index);
            setMultiTaxDetails(updatedTax);
            console.log('response.message, ', response.message)

            if(response.flag==200){
                setSnackbarMessage('Record deleted successfully');
                setOpenSnackbar(true);
            }
            else{
                setSnackbarMessage(response.message);
                setOpenSnackbar(true);
                return;
            }
        } catch (error) {
            console.error('Error deleting document:', error);
        }
    }; 
    
    const handleUpdateMultiTax = async (index) => {
        const tax = multiTaxDetails[index];
        if(tax.gstNumber==''){
            setSnackbarMessage('Please enter GST Number');
            setOpenSnackbar(true);
            return;
        }
        if(tax.fullAddress==''){
            setSnackbarMessage("Please enter 'Full Address'");
            setOpenSnackbar(true);
            return;
        }
        if(tax.state==''){
            setSnackbarMessage('Please enter state');
            setOpenSnackbar(true);
            return;
        }
        if(tax.placeOfSupply==''){
            setSnackbarMessage('Please enter place of supply');
            setOpenSnackbar(true);
            return;
        }
        if(tax.supplierName==''){
            setSnackbarMessage('Please enter Supplier Name');
            setOpenSnackbar(true);
            return;
        }
        if(tax.geofence=='' || tax.geofence==null){
            setSnackbarMessage('Geofence is missing');
            setOpenSnackbar(true);
            return;
        }
        if (!tax.taxRates || tax.taxRates.length === 0 ||
            tax.taxRates.some(r => !r.taxName?.trim() || r.percentage === '' || r.percentage === null)) {
            setSnackbarMessage('Please enter tax name and percentage');
            setOpenSnackbar(true);
            return;
        }
        const multiTaxData = {
            token: token,
            tax_id: tax.taxId,
            gst_number: tax.gstNumber,
            full_address: tax.fullAddress,
            state: tax.state,
            place_of_supply: tax.placeOfSupply,
            supplier_name: tax.supplierName,
            geofence: tax.geofence,
            tax_details: tax.taxRates,
        };
    
        try {
            const response = await makePostRequestToUrl(operationsUrl + '/shuttle/add_update_tax_details', multiTaxData);
            const updatedtax = [...multiTaxDetails];
            updatedtax[index].isModified = false;
            setMultiTaxDetails(updatedtax);
            if(response.flag==200){
                setSnackbarMessage(response.message);
                setOpenSnackbar(true);
                return;
            }
            else{
                setSnackbarMessage(response.message);
                setOpenSnackbar(true);
                return;
            }
        } catch (error) {
            console.error('Error updating document:', error);
            setSnackbarMessage('Failed to update document');
            setOpenSnackbar(true);
        }
    };

    const handleSaveNewMultiTax = async (index) => {
        const tax = multiTaxDetails[index];
        console.log('vehicleId = ', vehicleId)
        if(tax.gstNumber==''){
            setSnackbarMessage('Please enter GST Number');
            setOpenSnackbar(true);
            return;
        }
        if(tax.fullAddress==''){
            setSnackbarMessage("Please enter 'Full Address'");
            setOpenSnackbar(true);
            return;
        }
        if(tax.state==''){
            setSnackbarMessage('Please enter state');
            setOpenSnackbar(true);
            return;
        }
        if(tax.placeOfSupply==''){
            setSnackbarMessage('Please enter place of supply');
            setOpenSnackbar(true);
            return;
        }
        if(tax.supplierName==''){
            setSnackbarMessage('Please enter Supplier Name');
            setOpenSnackbar(true);
            return;
        }
        if(tax.geofence=='' || tax.geofence==null){
            setSnackbarMessage('Geofence is missing');
            setOpenSnackbar(true);
            return;
        }
        if (!tax.taxRates || tax.taxRates.length === 0 ||
            tax.taxRates.some(r => !r.taxName?.trim() || r.percentage === '' || r.percentage === null)) {
            setSnackbarMessage('Please enter tax name and percentage');
            setOpenSnackbar(true);
            return;
        }
        const multiTaxData = {
            token: token,
            // document_name: doc.name,
            vehicle_type_id: vehicleId,
            gst_number: tax.gstNumber,
            full_address: tax.fullAddress,
            state: tax.state,
            place_of_supply: tax.placeOfSupply,
            supplier_name: tax.supplierName,
            geofence: tax.geofence,
            tax_details: tax.taxRates,
            is_active: 1
        };
    
        try {
            const response = await makePostRequestToUrl(operationsUrl + '/shuttle/add_update_tax_details', multiTaxData);
    
            console.log('response = ', response);
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            if (response.flag == 200 && response.data.taxid) {
                setMultiTaxDetails((prevTax) => {
                    const updatedtax = [...prevTax];
                    updatedtax[index] = {
                        ...tax,
                        taxId: response.data.taxid, // Use the returned document_id
                        isModified: false, // Reset modified state
                    };
                    return updatedtax;
                });
                setSnackbarMessage(response.message);
                setOpenSnackbar(true);
            } else {
                setSnackbarMessage(response.message);
                setOpenSnackbar(true);
            }
        } catch (error) {
            console.error('Error saving new document:', error);
        }
    };

    useEffect(() => {
        if (fetchedTaxDetails && fetchedTaxDetails.length > 0) {
            const mapped = fetchedTaxDetails.map((t) => ({
                taxId: t.tax_id,
                gstNumber: t.gst_number || '',
                supplierName: t.supplier_name || '',
                placeOfSupply: t.place_of_supply || '',
                state: t.state || '',
                fullAddress: t.full_address || '',
                geofence: t.geofence
                    ? t.geofence[0].map(p => ({ lat: p.x, lng: p.y }))
                    : null,
                taxRates: (t.tax_details && t.tax_details.length > 0)
                    ? t.tax_details.map(r => ({ taxName: r.taxName ?? r.tax_name ?? '', percentage: r.percentage ?? '' }))
                    : [{ taxName: '', percentage: '' }],
                isModified: false,
            }));
            setMultiTaxDetails(mapped);
        }
    }, [fetchedTaxDetails]);
    
    return (
        <div style={{ position: 'relative', padding: '40px 0' }}>
            {/* Close Button Outside the Card */}
            <IconButton aria-label="close" onClick={onClose}
                style={{position:'absolute', top:'-15px', left:'1px', color:'#333', zIndex:10}}
            >
                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
            </IconButton>

            {/* Main Card/Container */}
            <Paper elevation={3}
                style={{padding: '30px',margin: '0 auto', maxWidth:'800px', backgroundColor: '#FFFFFF',borderRadius: '12px'}}
            >

                {/* Vehicle Section */}
                {editMode && (
                    <div style={{
                        display: 'flex',alignItems: 'center',backgroundColor: '#fff',padding: '10px 20px',marginBottom: '20px',
                        border: '1px solid #E0E0E0',borderRadius: '8px',boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Typography variant="body1" style={{ color: '#4A4A4A' }}>Vehicle</Typography>
                        <div style={{ display: 'flex', marginLeft: 'auto' }}>
                            <Button variant="contained" onClick={() => setEnabled(true)}
                                style={{
                                    backgroundColor: enabled ? '#0DBA78' : '#F4F4F4', minWidth: '80px',padding: '6px 16px',
                                    color:enabled?'#FFFFFF':'#9E9E9E',textTransform:'none',borderRadius:'8px 0 0 8px', boxShadow: 'none',
                                }}
                            >
                                Enable
                            </Button>
                            <Button variant="contained" onClick={() => setEnabled(false)}
                                style={{
                                    backgroundColor: !enabled ? '#D14545' : '#F4F4F4', color: !enabled ? '#FFFFFF' : '#9E9E9E',
                                    textTransform:'none', borderRadius:'0 8px 8px 0', boxShadow:'none',padding:'6px 16px', minWidth:'80px',
                                }}
                            >
                                Disable
                            </Button>
                        </div>
                    </div>
                )}

                {/* Heading */}
                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                {editMode ? 'Edit Vehicle Type' : 'Add Vehicle Type'}
                </Typography>

                {/* Input Fields */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>City <span style={{ color: 'red' }}>*</span></span>}
                            select fullWidth variant="outlined" value={city} onChange={(e) => setCity(e.target.value)}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            disabled={editMode}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'}
                            }}
                        >
                        {clientCities.map((cityObj) => (
                                <MenuItem key={cityObj.city_id} value={cityObj.city_name}>
                                    {cityObj.city_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <TextField label={<span>Vehicle Name <span style={{ color: 'red' }}>*</span></span>}
                            fullWidth variant="outlined" value={vehicleName}
                            onChange={(e) => setVehicleName(e.target.value)}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'}
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Ride Type <span style={{ color: 'red' }}>*</span></span>}
                            select
                            fullWidth
                            variant="outlined"
                            value={rideType}
                            onChange={(e) => setRideType(e.target.value)}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'},
                            }}
                        >
                            
                            {clientDemoType != 2 && getFilteredRideTypes().map(([id, label]) => (
                                <MenuItem key={id} value={label}>
                                    {label}
                                </MenuItem>
                            ))}
                            {clientDemoType == 2 && (
                                <MenuItem key={2} value={'Shuttle'}>
                                    {'Shuttle'}
                                </MenuItem>
                            )}

                        </TextField>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={<span>Vehicle Type <span style={{ color: 'red' }}>*</span></span>}
                            select
                            fullWidth
                            variant="outlined"
                            value={vehicleType}
                            onChange={(e) => setVehicleType(e.target.value)}
                            InputProps={{
                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                '& .MuiInputLabel-root': {fontSize: '16px'},
                            }}
                        >
                            {clientDemoType!=2 && Object.entries(constants.VehicleTypes).map(([id, label]) => (
                                <MenuItem key={id} value={label}>
                                    {label}
                                </MenuItem>
                            ))}
                            {clientDemoType==2 && (
                                <MenuItem key={4} value={'Shuttle'}>
                                    {'Shuttle'}
                                </MenuItem>
                            )}
                        </TextField>
                    </Grid>
                    
                    {clientDemoType!=2 && (
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Seats <span style={{ color: 'red' }}>*</span></span>}
                                fullWidth
                                variant="outlined"
                                value={seats}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setSeats(value);
                                    }
                                }}
                                InputProps={{
                                    style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                    '& .MuiInputLabel-root': {fontSize: '16px'}
                                }}
                            />
                        </Grid>
                    )}

                    {clientDemoType!=2 && (
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Min Driver Balance <span style={{ color: 'red' }}>*</span></span>}
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={minDriverBalance}
                                onChange={(e) => setMinDriverBalance(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '56px',
                                        fontSize: '16px',
                                        padding: '8px 14px',
                                        backgroundColor: '#FFFFFF',
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#E0E0E0',
                                    },
                                    '& .MuiInputLabel-root': {
                                        fontSize: '16px',
                                    },
                                }}
                            />
                        </Grid>
                    )}

                    {clientDemoType!=2 && (
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Display Order <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="0"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={displayOrder}
                                onChange={(e) => setDisplayOrder(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '56px',
                                        fontSize: '16px',
                                        padding: '8px 14px',
                                        backgroundColor: '#FFFFFF',
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#E0E0E0',
                                    },
                                    '& .MuiInputLabel-root': {
                                        fontSize: '16px',
                                    },
                                }}
                            />
                        </Grid>
                    )}

                    {(rideType !== 'Delivery') && 
                        <>
                        {clientDemoType!=2 && (
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label={<span>Convenience Charge <span style={{ color: 'red' }}>*</span></span>}
                                    placeholder="Enter Convenience Charge"
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    value={convenienceCharge}
                                    onChange={(e) => setConvenienceCharge(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {
                                            height: '56px',
                                            fontSize: '16px',
                                            padding: '8px 14px',
                                            backgroundColor: '#FFFFFF',
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#E0E0E0',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '16px',
                                        },
                                    }}
                                />
                            </Grid>
                        )}

                        {clientDemoType!=2 && (
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label={<span>Convenience Driver Cut <span style={{ color: 'red' }}>*</span></span>}
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    value={convenienceDriverCut}
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        if (value <= convenienceCharge) {
                                            setConvenienceDriverCut(value);
                                        } else {
                                            alert(`Convenience Driver Cut cannot exceed ${convenienceCharge}`);
                                        }
                                    }}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {
                                            height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF',
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                        '& .MuiInputLabel-root': {fontSize: '16px'},
                                    }}
                                />
                            </Grid>
                        )}

                        {clientDemoType!=2 && (
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label={<span>Platform Fee <span style={{ color: 'red' }}>*</span></span>}
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    value={platformFee}
                                    onChange={(e) => setPlatformFee(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'},
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                        '& .MuiInputLabel-root': {fontSize: '16px'},
                                    }}
                                />
                            </Grid>
                        )}
                        </>
                    }

                    {(rideType === 'Delivery' || rideType === 'Normal and Delivery') && 
                        <>
                        {clientDemoType!=2 && (
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label={<span>Delivery Convenience Charge <span style={{ color: 'red' }}>*</span></span>}
                                    placeholder="Enter Delivery Convenience Charge"
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    value={deliveryConvenienceCharge}
                                    onChange={(e) => setDeliveryConvenienceCharge(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {
                                            height: '56px',
                                            fontSize: '16px',
                                            padding: '8px 14px',
                                            backgroundColor: '#FFFFFF',
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#E0E0E0',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '16px',
                                        },
                                    }}
                                />
                            </Grid>
                        )}

                        {clientDemoType!=2 && (
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label={<span>Delivery Convenience Driver Cut <span style={{ color: 'red' }}>*</span></span>}
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    value={deliveryConvenienceDriverCut}
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        if (value <= deliveryConvenienceCharge) {
                                            setDeliveryConvenienceDriverCut(value);
                                        } else {
                                            alert(`Convenience Driver Cut cannot exceed ${convenienceCharge}`);
                                        }
                                    }}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {
                                            height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF',
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                        '& .MuiInputLabel-root': {fontSize: '16px'},
                                    }}
                                />
                            </Grid>
                        )}

                        {clientDemoType!=2 && (
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label={<span>Delivery Platform Fee <span style={{ color: 'red' }}>*</span></span>}
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    value={deliveryPlatformFee}
                                    onChange={(e) => setDeliveryPlatformFee(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'},
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                                        '& .MuiInputLabel-root': {fontSize: '16px'},
                                    }}
                                />
                            </Grid>
                        )}
                        </>
                    }
                </Grid>

                <Box style={{ height: '20px' }} />

                {(rideType !== 'Delivery') && 
                    <>

                        {/* Commission Section */}
                        {clientDemoType!=2 && (
                        <div style={{
                            marginBottom: '20px',
                            padding: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            maxWidth: '800px',
                            margin: '0 auto'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Commission</Typography>
                            </div>
                            <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Commission Percentage <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Percentage"
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        value={commissionPercentage}
                                        onChange={(e) => setCommissionPercentage(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0, max: 100 },
                                            style: {
                                                height: '50px',
                                                backgroundColor: '#F9F9F9',
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Commission Threshold <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Threshold"
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        value={commissionThreshold}
                                        onChange={(e) => setCommissionThreshold(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {
                                                height: '50px',
                                                backgroundColor: '#F9F9F9',
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Fixed Commission <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Fixed Amount"
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        value={fixedCommission}
                                        onChange={(e) => setFixedCommission(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {
                                                height: '50px',
                                                backgroundColor: '#F9F9F9',
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        )}

                        <Divider style={{ margin: '10px 0', visibility: 'hidden' }} />

                        {/* Taxes */}
                        {clientDemoType!=2 && (
                        <div style={{
                            marginBottom: '20px',padding: '10px',border: '1px solid #ccc',borderRadius: '8px',
                            backgroundColor: 'white',maxWidth: '800px',margin: '0 auto'}}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Taxes</Typography>
                            </div>
                            <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Tax Name <span style={{ color: 'red' }}>*</span></span>}
                                        fullWidth variant="outlined" type="text"
                                        value={taxName}
                                        onChange={(e) => setTaxName(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',backgroundColor: '#F9F9F9'}
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Tax Percentage <span style={{ color: 'red' }}>*</span></span>}
                                        fullWidth variant="outlined" type="number" value={taxPercentage}
                                        onChange={(e) => setTaxPercentage(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',backgroundColor: '#F9F9F9'}
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        )}

                    </>
                }

                {(rideType === 'Delivery' || rideType === 'Normal and Delivery') && 
                    <>
                        <Divider style={{ margin: '10px 0', visibility: 'hidden' }} />
                        {/* Commission Section */}
                        {clientDemoType!=2 && (
                        <div style={{
                            marginBottom: '20px',
                            padding: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            maxWidth: '800px',
                            margin: '0 auto'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Delivery Commission</Typography>
                            </div>
                            <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Delivery Commission Percentage <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Percentage"
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        value={deliveryCommissionPercentage}
                                        onChange={(e) => setDeliveryCommissionPercentage(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0, max: 100 },
                                            style: {
                                                height: '50px',
                                                backgroundColor: '#F9F9F9',
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Delivery Commission Threshold <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Threshold"
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        value={deliveryCommissionThreshold}
                                        onChange={(e) => setDeliveryCommissionThreshold(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {
                                                height: '50px',
                                                backgroundColor: '#F9F9F9',
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Delivery Fixed Commission <span style={{ color: 'red' }}>*</span></span>}
                                        placeholder="Enter Fixed Amount"
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        value={deliveryFixedCommission}
                                        onChange={(e) => setDeliveryFixedCommission(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {
                                                height: '50px',
                                                backgroundColor: '#F9F9F9',
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        )}

                        <Divider style={{ margin: '10px 0', visibility: 'hidden' }} />

                        {/* Taxes */}
                        {clientDemoType!=2 && (
                        <div style={{
                            marginBottom: '20px',padding: '10px',border: '1px solid #ccc',borderRadius: '8px',
                            backgroundColor: 'white',maxWidth: '800px',margin: '0 auto'}}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Delivery Taxes</Typography>
                            </div>
                            <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Delivery Tax Name <span style={{ color: 'red' }}>*</span></span>}
                                        fullWidth variant="outlined" type="text"
                                        value={deliveryTaxName}
                                        onChange={(e) => setDeliveryTaxName(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',backgroundColor: '#F9F9F9'}
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={<span>Delivery Tax Percentage <span style={{ color: 'red' }}>*</span></span>}
                                        fullWidth variant="outlined" type="number" value={deliveryTaxPercentage}
                                        onChange={(e) => setDeliveryTaxPercentag(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',backgroundColor: '#F9F9F9'}
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        )}

                    </>
                }

                <Divider style={{ margin: '10px 0', visibility: 'hidden' }} />

                {/* Vehicle Request Radius Settings */}
                {clientDemoType!=2 && (
                <div style={{
                    marginBottom: '20px',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>                        <div style={{
                        width: '36px', height: '36px', borderRadius: '8px',
                        backgroundColor: '#E1F5EE', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', flexShrink: 0
                    }}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="7.5" stroke="#0F6E56" strokeWidth="1"/>
                        <circle cx="9" cy="9" r="4.5" stroke="#0F6E56" strokeWidth="1" strokeDasharray="2 1.5"/>
                        <circle cx="9" cy="9" r="1.5" fill="#0F6E56"/>
                        </svg>
                    </div>
                    <div>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>Vehicle Request Radius Settings</Typography>
                        <Typography variant="caption" style={{ color: '#888', fontSize: '12px' }}>
                        Configure how the system expands search radius to find nearby drivers
                        </Typography>
                    </div>
                    </div>
                    <Grid container spacing={2} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Request Radius Threshold (in meters) <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Threshold Radius"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={requestRadiusThreshold}
                                onChange={(e) => setRequestRadiusThreshold(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Initial Request Radius (in meters) <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Initial Radius"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={initialRequestRadius}
                                onChange={(e) => setInitialRequestRadius(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label={<span>Request Radius Hop <span style={{ color: 'red' }}>*</span></span>}
                                placeholder="Enter Radius Increment"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={requestRadiusHop}
                                onChange={(e) => setRequestRadiusHop(e.target.value)}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '50px',
                                        backgroundColor: '#F9F9F9',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Divider style={{ margin: '20px 0' }} />

                    {/* Batch Size Slider */}
                    <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <div style={{ position: 'relative', marginBottom: '8px' }}>
                            <Typography 
                                variant="body2" 
                                style={{ 
                                    position: 'absolute',
                                    top: '-10px',
                                    left: '12px',
                                    backgroundColor: 'white',
                                    padding: '0 8px',
                                    fontWeight: '500', 
                                    fontSize: '13px',
                                    zIndex: 1
                                }}
                            >
                                Batch Size <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '12px',
                                border:'1px solid #aaaaaa',
                                padding:'14px 4px 14px 12px',
                                borderRadius:'6px',
                                marginTop: '8px'
                            }}>
                                <input
                                    type="range"
                                    min={1}
                                    max={10}
                                    step={1}
                                    value={batchSize}
                                    onChange={(e) => setBatchSize(Number(e.target.value))}
                                    style={{ flex: 1, accentColor: '#0F6E56', height: '10px', cursor: 'pointer' }}
                                />
                                <div style={{
                                    minWidth: '44px', textAlign: 'center',
                                    fontSize: '13px', fontWeight: '500',
                                    color: '#0F6E56', backgroundColor: '#E1F5EE',
                                    borderRadius: '6px', padding: '4px 10px'
                                }}>
                                    {batchSize}
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#aaa', marginTop: '4px' }}>
                                <span>1 driver</span>
                                <span>10 drivers</span>
                            </div>
                        </div>
                    </Grid>

                    {/* Request Accept Timer Slider */}
                    <Grid item xs={12} sm={6}>
                        <div style={{ position: 'relative', marginBottom: '8px' }}>
                            <Typography 
                                variant="body2" 
                                style={{ 
                                    position: 'absolute',
                                    top: '-10px',
                                    left: '12px',
                                    backgroundColor: 'white',
                                    padding: '0 8px',
                                    fontWeight: '500', 
                                    fontSize: '13px',
                                    zIndex: 1
                                }}
                            >
                                Request Accept Timer <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '12px',
                                border:'1px solid #aaaaaa',
                                padding:'14px 4px 14px 12px',
                                borderRadius:'6px',
                                marginTop: '8px'
                            }}>
                                <input
                                    type="range"
                                    min={10}
                                    max={60}
                                    step={1}
                                    value={requestAcceptTimer}
                                    onChange={(e) => setRequestAcceptTimer(Number(e.target.value))}
                                    style={{ flex: 1, accentColor: '#854F0B', height: '10px', cursor: 'pointer' }}
                                />
                                <div style={{
                                    minWidth: '44px', textAlign: 'center',
                                    fontSize: '13px', fontWeight: '500',
                                    color: '#854F0B', backgroundColor: '#FAEEDA',
                                    borderRadius: '6px', padding: '4px 10px'
                                }}>
                                    {requestAcceptTimer}s
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#aaa', marginTop: '4px' }}>
                                <span>10 sec</span>
                                <span>60 sec</span>
                            </div>
                        </div>
                    </Grid>
                    </Grid>
                </div>
                )}

                {/* <Divider style={{ margin: '10px 0', visibility: 'hidden' }} /> */}


                {/* Vehicle Type Images Section */}
                <div style={{
                    padding: '20px',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                            Vehicle Type Image
                        </Typography>

                        <Button component="label"
                            sx={{
                                textTransform:'none',fontSize:'14px',backgroundColor:'#E0EBFF',color:'#0065FF',
                                display:'flex',alignItems: 'center',gap:'4px',minWidth: '100px',
                            }}
                            startIcon={<img src={addIcon} alt="Add" style={{ width: '16px', height: '16px' }} />}
                            disabled={images.length > 0}
                        >
                            Add Image
                            <input type="file" accept="image/*" hidden onChange={handleAddImage}/>
                        </Button>
                    </div>

                    {images.length > 0 && (
                        <Typography variant="body2" style={{ marginBottom: '10px' }}>
                            Uploaded Image
                        </Typography>
                    )}

                    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                        {images.map((image, index) => (
                            <div key={index} style={{
                                padding: '10px',
                                border: '1px solid #D1D5DB',
                                borderRadius: '8px',
                                width: '150px',
                                textAlign: 'center',
                                backgroundColor: '#F9F9F9',
                            }}>
                                <img src={image.src} alt={image.name} style={{ width: '100%', borderRadius: '4px' }} />
                                <Typography variant="caption" style={{ display: 'block', marginTop: '5px' }}>{image.name}</Typography>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px' }}>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleViewImage(image)}
                                        sx={{
                                            minWidth: 0,
                                            padding: '6px',
                                            backgroundColor: '#1A1E25',
                                            '&:hover': {
                                                backgroundColor: '#1A1E25',
                                            },
                                        }}
                                    >
                                        <img src={eyeIcon} alt="View" style={{ width: '16px', height: '16px' }} />
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleDeleteImage(index)}
                                        sx={{
                                            minWidth: 0,
                                            padding: '6px',
                                            backgroundColor: '#C71F1F',
                                            '&:hover': {
                                                backgroundColor: '#C71F1F',
                                            },
                                        }}
                                    >
                                        <img src={binIcon} alt="Delete" style={{ width: '16px', height: '16px' }} />
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal for viewing the image */}
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="image-modal-title"
                    aria-describedby="image-modal-description"
                >
                    <Box sx={modalStyle}>
                        {currentImage && (
                            <img
                                src={currentImage.src}
                                alt={currentImage.name}
                                style={{ width: '100%', borderRadius: '8px' }}
                            />
                        )}
                    </Box>
                </Modal>


                {/* Submit and Reset Buttons */}
                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                    <Button variant="contained" color="primary" onClick={handleSubmit}
                        sx={{width:'140px',height:'50px',textTransform:'none',fontSize:'16px',backgroundColor:'#0065FF',color:'white'}}>
                        {editMode ? 'Update' : 'Save'}
                    </Button>
                    <Button variant="contained" onClick={onClose}
                        sx={{width:'140px',height:'50px',textTransform:'none',fontSize:'16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'}}>
                        Cancel
                    </Button>
                </div>

            </Paper>

                
            {/* Documents Section */}
            <Paper elevation={3}
                style={{
                    padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px', marginTop:'3%'
                }}
            >
                
                {/* {editMode && ( */}
                    <>
                        <div style={{
                            marginBottom: '20px',
                            padding: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            maxWidth: '800px',
                            margin: '0 auto'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Documents</Typography>
                            </div>
                            <>
                                {documents.map((doc, index) => (
                                    <div key={index} style={{ marginTop: '20px', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    label={<span>Documents Name <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth variant="outlined" value={doc.name}
                                                    onChange={(e) => handleDocumentChange(index, 'name', e.target.value)}
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            backgroundColor: '#F9F9F9',
                                                        },
                                                    }}
                                                    disabled={!vehiclecreated }
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField select
                                                    label={<span>Documents Type <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth variant="outlined" value={doc.type}
                                                    onChange={(e) => handleDocumentChange(index, 'type', e.target.value)}
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            backgroundColor: '#F9F9F9',
                                                        },
                                                    }}
                                                    disabled={!vehiclecreated}
                                                >
                                                    <MenuItem value="Image">Image</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label={<span>Number Of Images <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth type="number" variant="outlined" value={doc.images}
                                                    onChange={(e) => handleDocumentChange(index, 'images', e.target.value)}
                                                    InputProps={{
                                                        inputProps: { min: 0 }, // Prevent values less than zero
                                                    }}
                                                    disabled={!vehiclecreated}
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            backgroundColor: '#F9F9F9',
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                            <Typography sx={{}}>Expired action</Typography>
                                            <Select value={doc.expiredAction} onChange={(e) => handleDocumentChange(index, 'expiredAction', e.target.value)} fullWidth
                                                sx={{
                                                    height: '50px', borderRadius:'8px'
                                                }}
                                            >
                                                <MenuItem value="1">Block</MenuItem>
                                                <MenuItem value="2">Warning</MenuItem>
                                            </Select>
                                        </Grid>

                                        <div style={{
                                            display: 'flex',alignItems: 'center',justifyContent: 'space-between',marginTop: '20px',
                                            padding: '10px 20px',border: '1px solid #D1D5DB',borderRadius: '8px',backgroundColor: '#FFFFFF'
                                        }}>
                                            <Typography variant="body1" style={{ paddingLeft: '1px', color: '#4A4A4A'}}>
                                                Document No. Required <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    variant="body1"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    {doc.docNumberRequired ? 'Yes' : 'No'}
                                                </Typography>
                                                <IOSSwitch
                                                    checked={doc.docNumberRequired || false}
                                                    onChange={(e) => handleDocumentChange(index, 'docNumberRequired', e.target.checked)}
                                                    disabled={!vehiclecreated}
                                                />
                                            </div>
                                        </div>

                                        <div style={{
                                            display: 'flex',alignItems: 'center',justifyContent: 'space-between',marginTop: '20px',
                                            padding: '10px 20px',border: '1px solid #D1D5DB',borderRadius: '8px',backgroundColor: '#FFFFFF'
                                        }}>
                                            <Typography variant="body1" style={{ paddingLeft: '1px', color: '#4A4A4A'}}>
                                                Document Required <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    variant="body1"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    {doc.required ? 'Yes' : 'No'}
                                                </Typography>
                                                <IOSSwitch
                                                    checked={doc.required || false}
                                                    onChange={(e) => handleDocumentChange(index, 'required', e.target.checked)}
                                                    disabled={!vehiclecreated}
                                                />
                                            </div>
                                        </div>

                                        <div style={{
                                            display: 'flex',alignItems: 'center',justifyContent: 'space-between',marginTop: '20px',
                                            padding: '10px 20px',border: '1px solid #D1D5DB',borderRadius: '8px',backgroundColor: '#FFFFFF'
                                        }}>
                                            <Typography variant="body1" style={{ paddingLeft: '1px', color: '#4A4A4A'}}>
                                                Document Expiry Date Required <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography 
                                                    variant="body1"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    {doc.isDocExpired ? 'Yes' : 'No'}
                                                </Typography>
                                                <IOSSwitch
                                                    checked={doc.isDocExpired || false}
                                                    onChange={(e) => handleDocumentChange(index, 'isDocExpired', e.target.checked)}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                        {doc.docId ? (
                                            <Button 
                                                onClick={
                                                    doc.isModified
                                                        ? () => handleUpdateDocument(index) // Update if modified
                                                        : () => handleDeleteDocument(index) // Delete if not modified
                                                }
                                                sx={{
                                                    textTransform:'none',fontSize:'14px',backgroundColor: doc.isModified ? '#0065FF' : '#FDE8E8',
                                                    color: doc.isModified ? 'white' : '#D14545',padding: '8px 16px',borderRadius: '8px',
                                                }}
                                            >
                                                {doc.isModified ? 'Update' : 'Delete'}
                                            </Button>
                                        ) : (
                                            <Button onClick={() => handleSaveNewDocument(index)}
                                                sx={{
                                                    textTransform: 'none',fontSize: '14px',backgroundColor: '#1A1E25',color: 'white',
                                                    padding: '8px 16px',borderRadius: '8px',
                                                }}
                                            >
                                                Save
                                            </Button>
                                        )}
                                        </div>
                                    </div>
                                ))}

                                <Button
                                    onClick={() =>
                                        setDocuments([
                                            ...documents,
                                            { name: '', type: '', images: 1, required: false, isModified: false, docNumberRequired: false, isDocExpired: false, expiredAction: 1 },
                                        ])
                                    }
                                    sx={{
                                        marginTop:'10px',textTransform:'none',fontSize:'14px',backgroundColor:'#E0EBFF',
                                        color: '#0065FF',padding: '8px 16px',borderRadius: '8px'
                                    }}
                                >
                                    Add Document
                                </Button>
                            </>
                        </div>
                    </>
                {/* )} */}

            </Paper>

            {(multi_tax_system_enabled==1) && 
                <Paper elevation={3}
                    style={{
                        padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px', marginTop:'3%'
                    }}
                >
                    <div style={{
                        marginBottom: '20px', padding: '10px', border: '1px solid #ccc',
                        borderRadius: '8px', backgroundColor: 'white', maxWidth: '800px',margin: '0 auto'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Tax Details</Typography>
                        </div>

                        {multiTaxDetails.map((tax, index) => (
                            <div key={index} style={{ marginTop: '20px', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={<span>GST Number <span style={{ color: 'red' }}>*</span></span>}
                                            fullWidth variant="outlined" value={tax.gstNumber}
                                            onChange={(e) => handleMultiTaxChange(index, 'gstNumber', e.target.value)}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: '50px',
                                                    backgroundColor: '#F9F9F9',
                                                },
                                            }}
                                            // disabled={!vehiclecreated }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={<span>Supplier Name <span style={{ color: 'red' }}>*</span></span>}
                                            fullWidth variant="outlined" value={tax.supplierName}
                                            onChange={(e) => handleMultiTaxChange(index, 'supplierName', e.target.value)}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: '50px',
                                                    backgroundColor: '#F9F9F9',
                                                },
                                            }}
                                            // disabled={!vehiclecreated }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={<span>Place of Supply <span style={{ color: 'red' }}>*</span></span>}
                                            fullWidth variant="outlined" value={tax.placeOfSupply}
                                            onChange={(e) => handleMultiTaxChange(index, 'placeOfSupply', e.target.value)}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: '50px',
                                                    backgroundColor: '#F9F9F9',
                                                },
                                            }}
                                            // disabled={!vehiclecreated }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={<span>State <span style={{ color: 'red' }}>*</span></span>}
                                            fullWidth variant="outlined" value={tax.state}
                                            onChange={(e) => handleMultiTaxChange(index, 'state', e.target.value)}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: '50px',
                                                    backgroundColor: '#F9F9F9',
                                                },
                                            }}
                                            // disabled={!vehiclecreated }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={<span>Full Address <span style={{ color: 'red' }}>*</span></span>}
                                            fullWidth variant="outlined" value={tax.fullAddress}
                                            onChange={(e) => handleMultiTaxChange(index, 'fullAddress', e.target.value)}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    height: '50px',
                                                    backgroundColor: '#F9F9F9',
                                                },
                                            }}
                                            // disabled={!vehiclecreated }
                                        />
                                    </Grid>
                                    {/* <Grid item xs={6}>
                                        <Button variant='outlined' fullWidth sx={{height:'50px'}} onClick={() => openGeofenceModalForTax(index)}>Geofence</Button>
                                    </Grid> */}
                                    <Grid item xs={6}>
                                        {(() => {
                                            const hasGeofence = Array.isArray(tax.geofence) && tax.geofence.length > 0;
                                            return (
                                                <Button
                                                    // variant={hasGeofence ? 'contained' : 'outlined'}
                                                    variant='outlined'
                                                    fullWidth
                                                    sx={{
                                                        height: '50px',
                                                        textTransform: 'none',
                                                        ...(hasGeofence
                                                            ? { color: '#0DBA78',borderColor: '#0DBA78', boxShadow:'none', '&:hover': { backgroundColor: '#0BA76B' } }
                                                            : { color: '#0065FF', borderColor: '#0065FF' })
                                                    }}
                                                    startIcon={hasGeofence ? <CheckIcon /> : undefined}
                                                    onClick={() => openGeofenceModalForTax(index)}
                                                >
                                                    {hasGeofence ? 'Geofence Added' : 'Add Geofence'}
                                                </Button>
                                            );
                                        })()}
                                    </Grid>
                                </Grid>

                                {/* Tax Rates (name + percentage), repeatable per tax detail */}
                                <div style={{ marginTop: '20px', padding: '10px', border: '1px dashed #D1D5DB', borderRadius: '8px' }}>
                                    <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                                        Tax Rates
                                    </Typography>

                                    {(tax.taxRates || []).map((rate, rateIndex) => (
                                        <Grid container spacing={2} key={rateIndex} alignItems="center" style={{ marginBottom: '10px' }}>
                                            <Grid item xs={5.4}>
                                                <TextField
                                                    label={<span>Tax Name <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth variant="outlined" value={rate.taxName}
                                                    onChange={(e) => handleTaxRateChange(index, rateIndex, 'taxName', e.target.value)}
                                                    sx={{ '& .MuiInputBase-root': { height: '50px', backgroundColor: '#F9F9F9' } }}
                                                />
                                            </Grid>
                                            <Grid item xs={5.4}>
                                                <TextField
                                                    label={<span>Percentage <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth variant="outlined" type="number" value={rate.percentage}
                                                    onChange={(e) => handleTaxRateChange(index, rateIndex, 'percentage', e.target.value)}
                                                    InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                                                    sx={{ '& .MuiInputBase-root': { height: '50px', backgroundColor: '#F9F9F9' } }}
                                                />
                                            </Grid>
                                            <Grid item xs={1.2}>
                                                <IconButton
                                                    onClick={() => removeTaxRate(index, rateIndex)}
                                                    disabled={(tax.taxRates || []).length === 1}
                                                    sx={{
                                                        backgroundColor: '#FFE0E0', color: '#FF3B3B',
                                                        borderRadius: '8px', '&:hover': { backgroundColor: '#FFD0D0' }
                                                    }}
                                                >
                                                    <RemoveIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    ))}

                                    <Button
                                        startIcon={<AddIcon />}
                                        onClick={() => addTaxRate(index)}
                                        sx={{
                                            marginTop: '4px', textTransform: 'none', fontSize: '14px', backgroundColor: '#E0EBFF',
                                            color: '#0065FF', padding: '6px 14px', borderRadius: '8px'
                                        }}
                                    >
                                        Add Tax Rate
                                    </Button>
                                </div>


                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                    {tax.taxId ? (
                                        <Button 
                                            onClick={
                                                tax.isModified
                                                    ? () => handleUpdateMultiTax(index) // Update if modified
                                                    : () => handleDeleteMultiTax(index) // Delete if not modified
                                            }
                                            sx={{
                                                textTransform:'none',fontSize:'14px',backgroundColor: tax.isModified ? '#0065FF' : '#FDE8E8',
                                                color: tax.isModified ? 'white' : '#D14545',padding: '8px 16px',borderRadius: '8px',
                                            }}
                                        >
                                            {tax.isModified ? 'Update' : 'Delete'}
                                        </Button>
                                    ) : (
                                        <Button onClick={() => handleSaveNewMultiTax(index)}
                                            sx={{
                                                textTransform: 'none',fontSize: '14px',backgroundColor: '#1A1E25',color: 'white',
                                                padding: '8px 16px',borderRadius: '8px',
                                            }}
                                        >
                                            Save
                                        </Button>
                                    )}
                                </div>
                            </div>
                        ))}

                        <Button
                            onClick={() =>
                                setMultiTaxDetails([
                                    ...multiTaxDetails,
                                    {gstNumber: '', placeOfSupply: '', fullAddress: '', state: '', supplierName: '', geofence: null, taxRates: [{ taxName: '', percentage: '' }]}
                                ])
                            }
                            sx={{
                                marginTop:'10px',textTransform:'none',fontSize:'14px',backgroundColor:'#E0EBFF',
                                color: '#0065FF',padding: '8px 16px',borderRadius: '8px'
                            }}
                        >
                            Add Tax Details
                        </Button>
                    </div>
                </Paper>
            }

            <Modal open={opentaxGeofence} onClose={() => setOpenTaxGeofence(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Geofence
                    </Typography>
                    <hr/>
                    <Grid id="modal-modal-description">
                        <Grid item sx={{ marginTop:'2%'}}>
                            <CommonGeofence
                                key={activeTaxIndex}
                                geofence={activeTaxIndex !== null ? multiTaxDetails[activeTaxIndex].geofence : null}
                                onUpdatePolygon={handleUpdatePolygon}
                                setNullGeofence={() => {
                                    if (activeTaxIndex === null) return;
                                    const updated = [...multiTaxDetails];
                                    updated[activeTaxIndex].geofence = null;
                                    if (updated[activeTaxIndex].taxId) updated[activeTaxIndex].isModified = true;
                                    setMultiTaxDetails(updated);
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Button variant='contained' sx={{float:'right', textTransform:'none', bgcolor:'#0065ff'}} onClick={() => setOpenTaxGeofence(false)}>Done</Button>
                </Box>
            </Modal>

            {clientDemoType==2 && (
                <Button variant='contained' sx={{marginTop:'2%'}} onClick={onClose} fullWidth>Done</Button>
            )}

            {/* Vehicle Fare Settings Heading */}
            {clientDemoType!=2 && (
                <>
                    {(rideType !== 'Delivery') && 
                        <Paper elevation={3}
                            style={{
                                padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px', marginTop:'3%'
                            }}
                        >

                            {/* {editMode && ( */}
                                <>
                                    <Typography variant="h6" style={{marginBottom: '20px',fontWeight: 'bold',color: '#4A4A4A',fontSize: '20px'}}>
                                        Vehicle Fare Settings
                                    </Typography>

                                    {/* Distance Fare */}
                                    <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto'}}>
                                        
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Distance Fare</Typography>
                                        </div>

                                        {/* Base Fare and Minimum Fare */}
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label={<span>Base Fare <span style={{ color: 'red' }}>*</span></span>}
                                                    placeholder="Base Fare"
                                                    fullWidth
                                                    variant="outlined"
                                                    value={baseFare} // Set the value here
                                                    onChange={(e) => setBaseFare(e.target.value)} // Add onChange handler to update state
                                                    InputProps={{
                                                        style: {
                                                            height: '56px',
                                                            fontSize: '16px',
                                                            padding: '8px 14px',
                                                            backgroundColor: '#FFFFFF',
                                                        },
                                                    }}
                                                    disabled={!vehiclecreated}
                                                    sx={{
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#E0E0E0',
                                                        },
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '16px',
                                                            color: '#9E9E9E',
                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label={<span>Minimum Fare <span style={{ color: 'red' }}>*</span></span>}
                                                    placeholder="Minimum Fare"
                                                    fullWidth
                                                    variant="outlined"
                                                    value={minimumFare} // Set the value here
                                                    onChange={(e) => setMinimumFare(e.target.value)} // Add onChange handler to update state
                                                    InputProps={{
                                                        style: {
                                                            height: '56px',
                                                            fontSize: '16px',
                                                            padding: '8px 14px',
                                                            backgroundColor: '#FFFFFF',
                                                        },
                                                    }}
                                                    disabled={!vehiclecreated}
                                                    sx={{
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#E0E0E0',
                                                        },
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '16px',
                                                            color: '#9E9E9E',
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* Fare Threshold Section */}
                                        <Typography
                                            variant="body1"
                                            style={{
                                                marginTop: '20px',
                                                fontWeight: 'bold',
                                                color: '#4A4A4A',
                                            }}
                                        >
                                            Fare Threshold <span style={{ color: 'red' }}>*</span>
                                        </Typography>

                                        <div style={{
                                            padding: '20px',
                                            border: '1px solid #E0E0E0',
                                            borderRadius: '8px',
                                            backgroundColor: '#F9F9F9',
                                            marginTop: '10px'
                                        }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={5} sm={5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Distance (in km)</Typography>
                                                </Grid>
                                                <Grid item xs={5} sm={5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Price</Typography>
                                                </Grid>
                                            </Grid>

                                            {thresholds.map((threshold, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={5} sm={5} style={{ paddingRight: 0 }}>
                                                        <TextField
                                                            placeholder="0"
                                                            type="number"
                                                            variant="outlined"
                                                            fullWidth
                                                            value={threshold.distance}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handleThresholdChange(index, 'distance', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {
                                                                    height: '56px',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '8px 0 0 8px', // Only round the left side
                                                                    borderRight: 'none',
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={5} sm={5} style={{ paddingLeft: 0 }}>
                                                        <TextField
                                                            placeholder="min 0"
                                                            type="number"
                                                            variant="outlined"
                                                            fullWidth
                                                            value={threshold.price}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                if (value === '') {
                                                                    handleThresholdChange(index, 'price', '');
                                                                    return;
                                                                }

                                                                const numericValue = Math.max(0, Number(value));
                                                                handleThresholdChange(index, 'price', numericValue);
                                                            }}

                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {
                                                                    height: '56px',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '0 8px 8px 0', // Only round the right side
                                                                    borderLeft: 'none',
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {index === thresholds.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddThreshold}
                                                                startIcon={<PlusIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemoveThreshold(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Close
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </div>

                                    </div>

                                    {/* Time Fare */}
                                    <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                        
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Time Fare</Typography>
                                        </div>

                                        {/* Base Fare and Minimum Fare */}
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label={<span>Base Fare <span style={{ color: 'red' }}>*</span></span>}
                                                    placeholder="Base Fare"
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={!vehiclecreated}
                                                    value={timeBaseFare} // Set the value here
                                                    onChange={(e) => setTimeBaseFare(e.target.value)} // Add onChange handler to update state
                                                    InputProps={{
                                                        style: {
                                                            height: '56px',
                                                            fontSize: '16px',
                                                            padding: '8px 14px',
                                                            backgroundColor: '#FFFFFF',
                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label={<span>Minimum Fare <span style={{ color: 'red' }}>*</span></span>}
                                                    placeholder="Minimum Fare"
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={!vehiclecreated}
                                                    value={minimumTimeFare} // Set the value here
                                                    onChange={(e) => setMinimumTimeFare(e.target.value)} // Add onChange handler to update state
                                                    InputProps={{
                                                        style: {
                                                            height: '56px',
                                                            fontSize: '16px',
                                                            padding: '8px 14px',
                                                            backgroundColor: '#FFFFFF',
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* Fare Threshold Section */}
                                        <Typography
                                            variant="body1"
                                            style={{
                                                marginTop: '20px',
                                                fontWeight: 'bold',
                                                color: '#4A4A4A',
                                            }}
                                        >
                                            Fare Threshold <span style={{ color: 'red' }}>*</span>
                                        </Typography>

                                        <div style={{
                                            padding: '20px',
                                            border: '1px solid #E0E0E0',
                                            borderRadius: '8px',
                                            backgroundColor: '#F9F9F9',
                                            marginTop: '10px'
                                        }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={5} sm={5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Time (in minutes)</Typography>
                                                </Grid>
                                                <Grid item xs={5} sm={5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Price</Typography>
                                                </Grid>
                                            </Grid>

                                            {timeThresholds.map((threshold, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={5} sm={5} style={{ paddingRight: 0 }}>
                                                        <TextField
                                                            placeholder="0"
                                                            type="number"
                                                            variant="outlined"
                                                            fullWidth
                                                            value={threshold.time}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handleTimeThresholdChange(index, 'time', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {
                                                                    height: '56px',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '8px 0 0 8px', // Only round the left side
                                                                    borderRight: 'none',
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={5} sm={5} style={{ paddingLeft: 0 }}>
                                                        <TextField
                                                            placeholder="min 0"
                                                            type="number"
                                                            variant="outlined"
                                                            fullWidth
                                                            value={threshold.timePrice}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                if (value === '') {
                                                                    handleTimeThresholdChange(index, 'timePrice', '');
                                                                    return;
                                                                }

                                                                const numericValue = Math.max(0, Number(value));
                                                                handleTimeThresholdChange(index, 'timePrice', numericValue);
                                                            }}

                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {
                                                                    height: '56px',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '0 8px 8px 0', // Only round the right side
                                                                    borderLeft: 'none',
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {index === timeThresholds.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddTimeThreshold}
                                                                startIcon={<PlusIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemoveTimeThreshold(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Close
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </div>

                                    </div>

                                    {/* Waiting Changes Window */}
                                    <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                        
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Waiting Charges</Typography>
                                        </div>

                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                label={<span>Waiting Charges Window <span style={{ color: 'red' }}>*</span></span>}
                                                fullWidth variant="outlined"
                                                disabled={!vehiclecreated}
                                                value={waitingChangesWindow} // Set the value here
                                                onChange={(e) => setWaitingChangesWindow(e.target.value)} // Add onChange handler to update state
                                                InputProps={{
                                                    style: {height: '56px',fontSize: '16px',padding:'8px 14px', backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>

                                        {/* Fare Threshold Section */}
                                        <Typography variant="body1" style={{marginTop: '20px',fontWeight: 'bold',color: '#4A4A4A'}}>
                                            Waiting Charges Threshold <span style={{ color: 'red' }}>*</span>
                                        </Typography>

                                        <div style={{padding: '20px',border: '1px solid #E0E0E0',borderRadius: '8px',backgroundColor: '#F9F9F9',marginTop: '10px'}}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Min Time (in min)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Max Time (in min)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Charge</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Driver Cut</Typography>
                                                </Grid>
                                            </Grid>

                                            {waitingThresholds.map((threshold, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingRight: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            // value={threshold.minDist}
                                                            value={index === 0 ? Number(waitingChangesWindow)+1 : threshold.minDist}
                                                            onChange={(e) => handleWaitingThresholdChange(index, 'minDist', e.target.value)}
                                                            disabled={!vehiclecreated}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '8px 0 0 8px',borderRight: 'none'},
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.maxDist}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handleWaitingThresholdChange(index, 'maxDist', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.charge}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handleWaitingThresholdChange(index, 'charge', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.driverCut}
                                                            disabled={!vehiclecreated}
                                                            // onChange={(e) => handleWaitingThresholdChange(index, 'driverCut', e.target.value)}
                                                            onChange={(e) => {
                                                                const value = Number(e.target.value);
                                                                if (value <= threshold.charge) {
                                                                    handleWaitingThresholdChange(index, 'driverCut', value);
                                                                } else {
                                                                    alert(`Driver Cut cannot exceed ${threshold.charge}`);
                                                                }
                                                            }}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0 8px 8px 0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {index === waitingThresholds.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddWaitingThreshold}
                                                                startIcon={<PlusIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemoveWaitingThreshold(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Close
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </div>

                                    </div>

                                    {/* Stops Waiting Charges Window */}
                                    <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                        
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Stops Waiting Charges</Typography>
                                        </div>

                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                label={<span>Stops Waiting Charges Window <span style={{ color: 'red' }}>*</span></span>}
                                                fullWidth variant="outlined"
                                                disabled={!vehiclecreated}
                                                value={stopsWaitingChangesWindow} // Set the value here
                                                onChange={(e) => setStopsWaitingChangesWindow(e.target.value)} // Add onChange handler to update state
                                                InputProps={{
                                                    style: {height: '56px',fontSize: '16px',padding:'8px 14px', backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>

                                        {/* Fare Threshold Section */}
                                        <Typography variant="body1" style={{marginTop: '20px',fontWeight: 'bold',color: '#4A4A4A'}}>
                                            Stops Waiting Charges Threshold <span style={{ color: 'red' }}>*</span>
                                        </Typography>

                                        <div style={{padding: '20px',border: '1px solid #E0E0E0',borderRadius: '8px',backgroundColor: '#F9F9F9',marginTop: '10px'}}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Min Time (in min)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Max Time (in min)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Charge</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Driver Cut</Typography>
                                                </Grid>
                                            </Grid>

                                            {stopsWaitingThresholds.map((threshold, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingRight: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            // value={threshold.minDist}
                                                            disabled={!vehiclecreated}
                                                            value={index === 0 ? Number(stopsWaitingChangesWindow)+1 : threshold.minDist}
                                                            onChange={(e) => handleStopsWaitingThresholdChange(index, 'minDist', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '8px 0 0 8px',borderRight: 'none'},
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.maxDist}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handleStopsWaitingThresholdChange(index, 'maxDist', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.charge}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handleStopsWaitingThresholdChange(index, 'charge', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.driverCut}
                                                            disabled={!vehiclecreated}
                                                            // onChange={(e) => handleWaitingThresholdChange(index, 'driverCut', e.target.value)}
                                                            onChange={(e) => {
                                                                const value = Number(e.target.value);
                                                                if (value <= threshold.charge) {
                                                                    handleStopsWaitingThresholdChange(index, 'driverCut', value);
                                                                } else {
                                                                    alert(`Driver Cut cannot exceed ${threshold.charge}`);
                                                                }
                                                            }}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0 8px 8px 0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {index === stopsWaitingThresholds.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddStopsWaitingThreshold}
                                                                startIcon={<PlusIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemoveStopsWaitingThreshold(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Close
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </div>

                                    </div>


                                    {/* Luggage */}
                                    <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                        
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Luggage</Typography>
                                        </div>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label={<span>Luggage Charges <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={!vehiclecreated}
                                                    value={luggageCharges} // Set the value here
                                                    onChange={(e) => setLuggageCharges(e.target.value)}
                                                    InputProps={{
                                                        style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label={<span>Luggage Charges Driver Cut<span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth
                                                    variant="outlined"
                                                    value={luggageChargesDriverCut} // Set the value here
                                                    disabled={!vehiclecreated}
                                                    onChange={(e) => {
                                                        const value = Number(e.target.value);
                                                        if (value <= luggageCharges) {
                                                            setLuggageChargesDriverCut(value);
                                                        } else {
                                                            alert(`Luggage Charges Driver Cut cannot exceed ${luggageCharges}`);
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                    </div>

                                    {/* Pickup Distance Window */}
                                    <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                        
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Pickup Distance</Typography>
                                        </div>

                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                label={<span>Pickup Distance Window <span style={{ color: 'red' }}>*</span></span>}
                                                fullWidth variant="outlined"
                                                disabled={!vehiclecreated}
                                                value={pickupDistanceWindow} // Set the value here
                                                onChange={(e) => setPickupDistanceWindow(e.target.value)} // Add onChange handler to update state
                                                InputProps={{
                                                    style: {height: '56px',fontSize: '16px',padding:'8px 14px', backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>

                                        <Typography variant="body1" style={{marginTop: '20px',fontWeight: 'bold',color: '#4A4A4A'}}>
                                            Pickup Distance Threshold <span style={{ color: 'red' }}>*</span>
                                        </Typography>

                                        <div style={{padding: '20px',border: '1px solid #E0E0E0',borderRadius: '8px',backgroundColor: '#F9F9F9',marginTop: '10px'}}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Min Distance (in km)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Max Distance (in km)</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Charge</Typography>
                                                </Grid>
                                                <Grid item xs={2.5} sm={2.5}>
                                                    <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Driver Cut</Typography>
                                                </Grid>
                                            </Grid>

                                            {pickupThresholds.map((threshold, index) => (
                                                <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingRight: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={index === 0 ? Number(pickupDistanceWindow)+1 : threshold.pickupMinDist}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handlePickupThresholdChange(index, 'pickupMinDist', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '8px 0 0 8px',borderRight: 'none'},
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.pickupMaxDist}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handlePickupThresholdChange(index, 'pickupMaxDist', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.pickupCharge}
                                                            disabled={!vehiclecreated}
                                                            onChange={(e) => handlePickupThresholdChange(index, 'pickupCharge', e.target.value)}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                        <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                            value={threshold.pickupDriverCut}
                                                            disabled={!vehiclecreated}
                                                            // onChange={(e) => handlePickupThresholdChange(index, 'pickupDriverCut', e.target.value)}
                                                            onChange={(e) => {
                                                                const value = Number(e.target.value);
                                                                if (value <= threshold.pickupCharge) {
                                                                    handlePickupThresholdChange(index, 'pickupDriverCut', value);
                                                                } else {
                                                                    alert(`Driver Cut cannot exceed ${threshold.pickupCharge}`);
                                                                }
                                                            }}
                                                            InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0 8px 8px 0',borderLeft: 'none'}
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {index === pickupThresholds.length - 1 ? (
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={handleAddPickupThreshold}
                                                                startIcon={<PlusIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#0065FF',
                                                                    borderColor: '#0065FF',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Add
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() => handleRemovePickupThreshold(index)}
                                                                startIcon={<CloseIcon />}
                                                                style={{
                                                                    height: '56px',
                                                                    color: '#D14545',
                                                                    borderColor: '#D14545',
                                                                    textTransform: 'none',
                                                                    borderRadius: '8px',
                                                                    minWidth: '80px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Close
                                                            </Button>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </div>

                                    </div>

                                    {/* Additional Authentication Amount */}
                                    <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                        
                                        <div style={{alignItems: 'center', marginBottom:'3%'}}>
                                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Additional Authentication Amount</Typography>
                                            <Typography style={{color:'#83888E',fontSize:'12px'}}>(This will be applicable for pre authorized payment gateways only)</Typography>
                                        </div>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Label style={{fontSize:'14px', marginBottom:'2px', color:'#83888E'}}>Amount Type</Label>
                                                <Select 
                                                    value={authAmountType} fullWidth
                                                    onChange={(e) => {
                                                        setAuthAmountType( e.target.value)
                                                        if(e.target.value === '2' && authAmount>100) {
                                                            setAuthAmount(100)
                                                        }
                                                    }}
                                                    disabled={!vehiclecreated}
                                                    style={{ height: '56px',padding: '8px 14px', backgroundColor:'#FFFFFF'}}>
                                                    <MenuItem value="1">Flat</MenuItem>
                                                    <MenuItem value="2">Percentage</MenuItem>
                                                </Select>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Label style={{fontSize:'14px', marginBottom:'2px', color:'#83888E'}}>Amount<span style={{ color: 'red' }}>*</span></Label>
                                                {/* <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    value={authAmount}
                                                    onChange={(e) => {
                                                        const value = Number(e.target.value);
                                                        setAuthAmount(value);
                                                        if(e.target.value >100 && authAmountType == '2') {
                                                            setAuthAmount(100)
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                    }}
                                                /> */}

                                                <TextField fullWidth variant="outlined" value={authAmount}
                                                    onChange={(e) => {
                                                        let value = e.target.value;
                                                        // Prevent non-numeric input (only digits allowed)
                                                        if (!/^\d*$/.test(value)) return;
                                                        // Convert to number
                                                        value = Number(value);
                                                        // Prevent negative
                                                        if (value < 0) return;
                                                        // Apply max limit if type == '2'
                                                        if (value > 100 && authAmountType === '2') {
                                                            value = 100;
                                                        }
                                                        setAuthAmount(value);
                                                    }}
                                                    disabled={!vehiclecreated}
                                                    onKeyDown={(e) => {
                                                        // Block "e", "E", "+", "-", "."  to prevent non-numeric entries
                                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                        e.preventDefault();
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {height: "56px", fontSize: "16px", padding: "8px 14px", backgroundColor: "#FFFFFF"},
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                    </div>

                                    {/* Bid Limit */}
                                    {(reverse_bid_enabled_panel!=0) && (
                                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                        
                                            <div style={{alignItems: 'center', marginBottom:'2%'}}>
                                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Bid Limit</Typography>
                                                {/* <Typography style={{color:'#83888E',fontSize:'12px'}}>(This will be applicable for pre authorized payment gateways only)</Typography> */}
                                            </div>

                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span style={{fontSize:'14px'}}>Customer Bid Margin</span>}
                                                        fullWidth
                                                        variant="outlined" type="number"
                                                        disabled={!vehiclecreated}
                                                        value={customerBidMargin} // Set the value here
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (val === '') {
                                                                setCustomerBidMargin('');
                                                                return;
                                                            }
                                                            const num = Number(val);
                                                            if (!Number.isNaN(num) && num > 0) {
                                                                setCustomerBidMargin(val);
                                                            }
                                                        }}
                                                        onKeyDown={(evt) => {
                                                            if (["e", "E", "+", "-"].includes(evt.key)) {
                                                                evt.preventDefault();
                                                            }
                                                        }}
                                                        inputProps={{ min: 0.01, step: 'any' }}
                                                        InputProps={{
                                                            style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span style={{fontSize:'14px'}}>Driver Bid Margin</span>}
                                                        fullWidth
                                                        variant="outlined" type='number'
                                                        value={driverBidMargin} // Set the value here
                                                        disabled={!vehiclecreated}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (val === '') {
                                                                setDriverBidMargin('');
                                                                return;
                                                            }
                                                            const num = Number(val);
                                                            if (!Number.isNaN(num) && num > 0) {
                                                                setDriverBidMargin(val);
                                                            }
                                                        }}
                                                        onKeyDown={(evt) => {
                                                            if (["e", "E", "+", "-"].includes(evt.key)) {
                                                                evt.preventDefault();
                                                            }
                                                        }}
                                                        // inputProps={{ min: 0.01, step: 'any' }}
                                                        InputProps={{
                                                            style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span style={{fontSize:'14px'}}>Customer Lower Bid Limit</span>}
                                                        fullWidth
                                                        variant="outlined" type="number"
                                                        disabled={!vehiclecreated}
                                                        value={customerLowerBidLimit} // Set the value here
                                                        onChange={(e) => setCustomerLowerBidLimit(e.target.value)}
                                                        onKeyDown={(evt) => {
                                                            if (["e", "E", "+", "-"].includes(evt.key)) {
                                                                evt.preventDefault();
                                                            }
                                                        }}
                                                        InputProps={{
                                                            style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span style={{fontSize:'14px'}}>Customer Upper Bid Limit</span>}
                                                        fullWidth
                                                        variant="outlined" type='number'
                                                        value={customerUpperBidLimit} // Set the value here
                                                        disabled={!vehiclecreated}
                                                        onChange={(e) => setCustomerUpperBidLimit(e.target.value)}
                                                        onKeyDown={(evt) => {
                                                            if (["e", "E", "+", "-"].includes(evt.key)) {
                                                                evt.preventDefault();
                                                            }
                                                        }}
                                                        InputProps={{
                                                            style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span style={{fontSize:'14px'}}>Driver Upper Bid Limit</span>}
                                                        fullWidth
                                                        variant="outlined" type='number'
                                                        disabled={!vehiclecreated}
                                                        value={driverUpperBidLimit} // Set the value here
                                                        onChange={(e) => setDriverUpperBidLimit(e.target.value)}
                                                        onKeyDown={(evt) => {
                                                            if (["e", "E", "+", "-"].includes(evt.key)) {
                                                                evt.preventDefault();
                                                            }
                                                        }}
                                                        InputProps={{
                                                            style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                        </div>
                                    )}

                                    {/* Save Button */}
                                    {isFareModified && (
                                        <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
                                            <Button
                                                variant="contained" color="primary" onClick={handleSaveFareSettings}
                                                style={{
                                                    height: '56px',width: '800px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#1A1E25',
                                                    color: '#FFFFFF', textTransform: 'none', borderRadius: '8px', padding: '0 30px',
                                                }}
                                            >
                                                Save
                                            </Button>
                                        </Grid>
                                    )}
                                </>
                            {/* )} */}
                            
                        </Paper>
                    }

                    {(rideType === 'Delivery' || rideType === 'Normal and Delivery') && 
                    <Paper elevation={3}
                        style={{
                            padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px', marginTop:'3%', paddingTop:'10px'
                        }}>
                        {/* {(rideType==3 || rideType==4) &&  */}
                                <div style={{alignItems: 'center', display:'flex', marginTop:'2%'}}>
                                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Parcel Delivery Fare Setting</Typography>
                                    <KeyboardArrowDownIcon 
                                        onClick={() => setIsExpandedDelivery(!isExpandedDelivery)}
                                        sx={{
                                            ml:'auto', 
                                            color:'#9FA3A7', 
                                            cursor:'pointer',
                                            transform: isExpandedDelivery ? 'rotate(180deg)' : 'rotate(0)',
                                            transition: 'transform 0.3s ease'
                                        }}
                                    />
                                </div>
                                {isExpandedDelivery && 
                                    <>
                                        <Grid2 sx={{backgroundColor:'#F7F7F7', borderRadius:'12px', padding:'2%', mt:'2%'}}>
                                            <Grid2 >
                                                <Typography sx={{fontSize:'16px', fontWeight:500}}>Weight-wise Pricing</Typography>
                                                <Typography sx={{color:'#9FA3A7', fontSize:'14px'}}>Set fares based on parcel weight</Typography>
                                            </Grid2>
                                            <Grid2 container spacing={2} size={12} sx={{backgroundColor:'#fff', padding:'2%', borderRadius:'12px', marginTop:'1%'}}>
                                                <Grid2 size={6}>
                                                    <Typography>Select Unit</Typography>
                                                    <Select value={weightUnit} 
                                                        onChange={(e) => setWeightUnit(e.target.value)} fullWidth
                                                        disabled={!vehiclecreated}
                                                        style={{height:'50px'}}>
                                                            <MenuItem value="1">kilogram (kg)</MenuItem>
                                                            <MenuItem value="2">gram (g)</MenuItem>
                                                            <MenuItem value="3">milligram (mg)</MenuItem>
                                                            <MenuItem value="4">microgram (μg)</MenuItem>
                                                            <MenuItem value="5">tonne (t)</MenuItem>
                                                            <MenuItem value="6">pound (lb)</MenuItem>
                                                            <MenuItem value="7">ounce (oz)</MenuItem>
                                                    </Select>
                                                </Grid2>

                                                <Grid2 size={6}>
                                                    <Typography>Per Unit Fare</Typography>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined" type='number'
                                                        disabled={!vehiclecreated}
                                                        value={perWeightFare} // Set the value here
                                                        onChange={(e) => setPerWeightFare(e.target.value)}
                                                        onKeyDown={(evt) => {
                                                            if (["e", "E", "+", "-"].includes(evt.key)) {
                                                                evt.preventDefault();
                                                            }
                                                        }}
                                                        InputProps={{
                                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                        }}
                                                    />
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 sx={{backgroundColor:'#F7F7F7', borderRadius:'12px', padding:'2%', mt:'2%'}}>
                                            <Grid2 >
                                                <Typography sx={{fontSize:'16px', fontWeight:500}}>Size-wise Pricing</Typography>
                                                <Typography sx={{color:'#9FA3A7', fontSize:'14px'}}>Set fares based on parcel size</Typography>
                                            </Grid2>
                                            <Grid2 container spacing={2} size={12} sx={{backgroundColor:'#fff', padding:'2%', borderRadius:'12px', marginTop:'1%'}}>
                                                <Grid2 size={6}>
                                                    <Typography>Select Unit</Typography>
                                                    <Select value={sizeUnit} 
                                                        onChange={(e) => setSizeUnit(e.target.value)} fullWidth
                                                        disabled={!vehiclecreated}
                                                        style={{height:'50px'}}>
                                                            <MenuItem value="1">meter (m)</MenuItem>
                                                            <MenuItem value="2">centimeter (cm)</MenuItem>
                                                            <MenuItem value="3">millimeter (mm)</MenuItem>
                                                            <MenuItem value="4">micrometer (μm)</MenuItem>
                                                            <MenuItem value="5">foot (ft)</MenuItem>
                                                            <MenuItem value="6">inch (in)</MenuItem>
                                                    </Select>
                                                </Grid2>

                                                <Grid2 size={6}>
                                                    <Typography>Per Unit Fare</Typography>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined" type='number'
                                                        disabled={!vehiclecreated}
                                                        value={perSizeFare} // Set the value here
                                                        onChange={(e) => setPerSizeFare(e.target.value)}
                                                        onKeyDown={(evt) => {
                                                            if (["e", "E", "+", "-"].includes(evt.key)) {
                                                                evt.preventDefault();
                                                            }
                                                        }}
                                                        InputProps={{
                                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                        }}
                                                    />
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>

                                        {/* Distance Fare */}
                                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'2%'}}>
                                            
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Distance Fare</Typography>
                                            </div>

                                            {/* Base Fare and Minimum Fare */}
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span>Base Fare <span style={{ color: 'red' }}>*</span></span>}
                                                        placeholder="Base Fare"
                                                        fullWidth
                                                        variant="outlined"
                                                        disabled={!vehiclecreated}
                                                        value={deliveryDistanceFare} // Set the value here
                                                        onChange={(e) => setDeliveryDistanceFare(e.target.value)} // Add onChange handler to update state
                                                        InputProps={{
                                                            style: {
                                                                height: '56px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#E0E0E0',
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                fontSize: '16px',
                                                                color: '#9E9E9E',
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span>Minimum Fare <span style={{ color: 'red' }}>*</span></span>}
                                                        placeholder="Minimum Fare"
                                                        fullWidth
                                                        variant="outlined"
                                                        disabled={!vehiclecreated}
                                                        value={deliverydistanceMinFare} // Set the value here
                                                        onChange={(e) => setDeliveryDistanceMinFare(e.target.value)} // Add onChange handler to update state
                                                        InputProps={{
                                                            style: {
                                                                height: '56px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#E0E0E0',
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                fontSize: '16px',
                                                                color: '#9E9E9E',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* Fare Threshold Section */}
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    marginTop: '20px',
                                                    fontWeight: 'bold',
                                                    color: '#4A4A4A',
                                                }}
                                            >
                                                Fare Threshold <span style={{ color: 'red' }}>*</span>
                                            </Typography>

                                            <div style={{
                                                padding: '20px',
                                                border: '1px solid #E0E0E0',
                                                borderRadius: '8px',
                                                backgroundColor: '#F9F9F9',
                                                marginTop: '10px'
                                            }}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={5} sm={5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Distance (in km)</Typography>
                                                    </Grid>
                                                    <Grid item xs={5} sm={5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Price</Typography>
                                                    </Grid>
                                                </Grid>

                                                {deliveryDistFareThreshold.map((threshold, index) => (
                                                    <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                        <Grid item xs={5} sm={5} style={{ paddingRight: 0 }}>
                                                            <TextField
                                                                placeholder="0"
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                disabled={!vehiclecreated}
                                                                value={threshold.distance}
                                                                onChange={(e) => handleDeliveryDistFareThresholdChange(index, 'distance', e.target.value)}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {
                                                                        height: '56px',
                                                                        backgroundColor: '#FFFFFF',
                                                                        borderRadius: '8px 0 0 8px', // Only round the left side
                                                                        borderRight: 'none',
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={5} sm={5} style={{ paddingLeft: 0 }}>
                                                            <TextField
                                                                placeholder="0"
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                disabled={!vehiclecreated}
                                                                value={threshold.price}
                                                                onChange={(e) => handleDeliveryDistFareThresholdChange(index, 'price', e.target.value)}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {
                                                                        height: '56px',
                                                                        backgroundColor: '#FFFFFF',
                                                                        borderRadius: '0 8px 8px 0', // Only round the right side
                                                                        borderLeft: 'none',
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            {index === deliveryDistFareThreshold.length - 1 ? (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    onClick={handleAddDeliveryDistFareThreshold}
                                                                    startIcon={<PlusIcon />}
                                                                    style={{
                                                                        height: '56px',
                                                                        color: '#0065FF',
                                                                        borderColor: '#0065FF',
                                                                        textTransform: 'none',
                                                                        borderRadius: '8px',
                                                                        minWidth: '80px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    Add
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    onClick={() => handleRemoveDeliveryDistFareThreshold(index)}
                                                                    startIcon={<CloseIcon />}
                                                                    style={{
                                                                        height: '56px',
                                                                        color: '#D14545',
                                                                        borderColor: '#D14545',
                                                                        textTransform: 'none',
                                                                        borderRadius: '8px',
                                                                        minWidth: '80px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    Close
                                                                </Button>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </div>

                                        </div>

                                        {/* Time Fare */}
                                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                            
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Time Fare</Typography>
                                            </div>

                                            {/* Base Fare and Minimum Fare */}
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span>Base Fare <span style={{ color: 'red' }}>*</span></span>}
                                                        placeholder="Base Fare"
                                                        fullWidth
                                                        variant="outlined"
                                                        disabled={!vehiclecreated}
                                                        value={deliveryTimeFare} // Set the value here
                                                        onChange={(e) => setDeliveryTimeFare(e.target.value)} // Add onChange handler to update state
                                                        InputProps={{
                                                            style: {
                                                                height: '56px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span>Minimum Fare <span style={{ color: 'red' }}>*</span></span>}
                                                        placeholder="Minimum Fare"
                                                        fullWidth
                                                        variant="outlined"
                                                        disabled={!vehiclecreated}
                                                        value={deliveryTimeMinFare} // Set the value here
                                                        onChange={(e) => setDeliveryTimeMinFare(e.target.value)} // Add onChange handler to update state
                                                        InputProps={{
                                                            style: {
                                                                height: '56px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* Fare Threshold Section */}
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    marginTop: '20px',
                                                    fontWeight: 'bold',
                                                    color: '#4A4A4A',
                                                }}
                                            >
                                                Fare Threshold <span style={{ color: 'red' }}>*</span>
                                            </Typography>

                                            <div style={{
                                                padding: '20px',
                                                border: '1px solid #E0E0E0',
                                                borderRadius: '8px',
                                                backgroundColor: '#F9F9F9',
                                                marginTop: '10px'
                                            }}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={5} sm={5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Time (in minutes)</Typography>
                                                    </Grid>
                                                    <Grid item xs={5} sm={5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Price</Typography>
                                                    </Grid>
                                                </Grid>

                                                {deliveryTimeFareThreshold.map((threshold, index) => (
                                                    <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                        <Grid item xs={5} sm={5} style={{ paddingRight: 0 }}>
                                                            <TextField
                                                                placeholder="0"
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                value={threshold.time}
                                                                disabled={!vehiclecreated}
                                                                onChange={(e) => handleDeliveryTimeThresholdChange(index, 'time', e.target.value)}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {
                                                                        height: '56px',
                                                                        backgroundColor: '#FFFFFF',
                                                                        borderRadius: '8px 0 0 8px', // Only round the left side
                                                                        borderRight: 'none',
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={5} sm={5} style={{ paddingLeft: 0 }}>
                                                            <TextField
                                                                placeholder="0"
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                value={threshold.timePrice}
                                                                disabled={!vehiclecreated}
                                                                onChange={(e) => handleDeliveryTimeThresholdChange(index, 'timePrice', e.target.value)}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {
                                                                        height: '56px',
                                                                        backgroundColor: '#FFFFFF',
                                                                        borderRadius: '0 8px 8px 0', // Only round the right side
                                                                        borderLeft: 'none',
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            {index === deliveryTimeFareThreshold.length - 1 ? (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    onClick={handleAddDeliveryTimeThreshold}
                                                                    startIcon={<PlusIcon />}
                                                                    style={{
                                                                        height: '56px',
                                                                        color: '#0065FF',
                                                                        borderColor: '#0065FF',
                                                                        textTransform: 'none',
                                                                        borderRadius: '8px',
                                                                        minWidth: '80px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    Add
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    onClick={() => handleRemoveDeliveryTimeThreshold(index)}
                                                                    startIcon={<CloseIcon />}
                                                                    style={{
                                                                        height: '56px',
                                                                        color: '#D14545',
                                                                        borderColor: '#D14545',
                                                                        textTransform: 'none',
                                                                        borderRadius: '8px',
                                                                        minWidth: '80px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    Close
                                                                </Button>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </div>

                                        </div>

                                        {/* Waiting Changes Window */}
                                        <div style={{marginBottom:'20px',padding: '10px',border:'1px solid #ccc',borderRadius:'8px',backgroundColor:'white',maxWidth: '800px',margin: '0 auto', marginTop:'4%'}}>
                                            
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'4%'}}>
                                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Waiting Charges</Typography>
                                            </div>

                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    label={<span>Waiting Charges Window <span style={{ color: 'red' }}>*</span></span>}
                                                    fullWidth variant="outlined"
                                                    value={deliveryWaitingChangesWindow} // Set the value here
                                                    disabled={!vehiclecreated}
                                                    onChange={(e) => setDeliveryWaitingChangesWindow(e.target.value)} // Add onChange handler to update state
                                                    InputProps={{
                                                        style: {height: '56px',fontSize: '16px',padding:'8px 14px', backgroundColor: '#FFFFFF'}
                                                    }}
                                                />
                                            </Grid>

                                            {/* Fare Threshold Section */}
                                            <Typography variant="body1" style={{marginTop: '20px',fontWeight: 'bold',color: '#4A4A4A'}}>
                                                Waiting Charges Threshold <span style={{ color: 'red' }}>*</span>
                                            </Typography>

                                            <div style={{padding: '20px',border: '1px solid #E0E0E0',borderRadius: '8px',backgroundColor: '#F9F9F9',marginTop: '10px'}}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={2.5} sm={2.5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Min Time (in min)</Typography>
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Max Time (in min)</Typography>
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Charge</Typography>
                                                    </Grid>
                                                    <Grid item xs={2.5} sm={2.5}>
                                                        <Typography variant="subtitle2" style={{ color: '#4A4A4A' }}>Driver Cut</Typography>
                                                    </Grid>
                                                </Grid>

                                                {deliveryWaitingThresholds.map((threshold, index) => (
                                                    <Grid container spacing={0} key={index} style={{ marginTop: '10px' }}>
                                                        <Grid item xs={2.5} sm={2.5} style={{ paddingRight: 0 }}>
                                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                                // value={threshold.minDist}
                                                                value={index === 0 ? Number(deliveryWaitingChangesWindow)+1 : threshold.minDist}
                                                                disabled={!vehiclecreated}
                                                                onChange={(e) => handleDeliveryWaitingThresholdChange(index, 'minDist', e.target.value)}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '8px 0 0 8px',borderRight: 'none'},
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                                value={threshold.maxDist}
                                                                disabled={!vehiclecreated}
                                                                onChange={(e) => handleDeliveryWaitingThresholdChange(index, 'maxDist', e.target.value)}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                                value={threshold.charge}
                                                                disabled={!vehiclecreated}
                                                                onChange={(e) => handleDeliveryWaitingThresholdChange(index, 'charge', e.target.value)}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0',borderLeft: 'none'}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2.5} sm={2.5} style={{ paddingLeft: 0 }}>
                                                            <TextField placeholder="0" type="number" variant="outlined" fullWidth
                                                                value={threshold.driverCut}
                                                                disabled={!vehiclecreated}
                                                                // onChange={(e) => handleWaitingThresholdChange(index, 'driverCut', e.target.value)}
                                                                onChange={(e) => {
                                                                    const value = Number(e.target.value);
                                                                    if (value <= threshold.charge) {
                                                                        handleDeliveryWaitingThresholdChange(index, 'driverCut', value);
                                                                    } else {
                                                                        alert(`Driver Cut cannot exceed ${threshold.charge}`);
                                                                    }
                                                                }}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: {height: '56px',backgroundColor: '#FFFFFF',borderRadius: '0 8px 8px 0',borderLeft: 'none'}
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            {index === waitingThresholds.length - 1 ? (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    onClick={handleAddDeliveryWaitingThreshold}
                                                                    startIcon={<PlusIcon />}
                                                                    style={{
                                                                        height: '56px',
                                                                        color: '#0065FF',
                                                                        borderColor: '#0065FF',
                                                                        textTransform: 'none',
                                                                        borderRadius: '8px',
                                                                        minWidth: '80px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    Add
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    onClick={() => handleRemoveDeliveryWaitingThreshold(index)}
                                                                    startIcon={<CloseIcon />}
                                                                    style={{
                                                                        height: '56px',
                                                                        color: '#D14545',
                                                                        borderColor: '#D14545',
                                                                        textTransform: 'none',
                                                                        borderRadius: '8px',
                                                                        minWidth: '80px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    Close
                                                                </Button>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </div>

                                        </div>


                                        <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
                                            <Button
                                                variant="contained" color="primary" onClick={handleSaveDeliveryFareSettings}
                                                style={{
                                                    height: '56px',width: '800px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#1A1E25',
                                                    color: '#FFFFFF', textTransform: 'none', borderRadius: '8px', padding: '0 30px',
                                                }}
                                            >
                                                Save
                                            </Button>
                                        </Grid>
                                    </>
                                }
                        {/* } */}
                    </Paper>
                    }
                </>
            )}

            {/* Success/Failure Snackbar */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackbar(false)}
                message={snackbarMessage}
                action={
                    <Button color="primary" size="small" onClick={() => setOpenSnackbar(false)}>
                        Close
                    </Button>
                }
            />
        </div>
    );
};

export default AddVehicle;